import "../../App.css";
import "../../styles/tabStyle.css";
import "../../styles/login.css";
import Sidebar from "../Sidebar";
import { withRouter } from "react-router-dom";
import AutocompleteInputModule from "../AutoComplete";
import React, { useState, useEffect, useRef } from "react";
import UserTab from "../UserTab";
import Parametros from "../Parametros";
import Table from "../Table";
import FormularioModulos from "../FormulariosModulos";
import AutocompleteForms from "../AutocompleteForms";
import CurrentUser from "../CurrentUser";
import loadGif from "../../imagenes/load.gif";
import ReactSelect from "react-select";
import { useParams } from "react-router-dom";
import EliminarElemento from "../EliminarElemento";

const PRINCIPAL_NOTEBOOK_NAME = "PRINCIPAL";

function AdministracionCausas(props) {
  const [editableCausa, setEditableCausa] = useState(false);
  const { id } = useParams();

  const [storage, setStorage] = useState(false);
  // eslint-disable-next-line
  const [usuario, setUsuario] = useState(CurrentUser.user);

  const { history } = props;

  const [formularioUpdate, setformularioUpdate] = useState({});

  const [causaState, setCausaState] = useState({});
  //
  // eslint-disable-next-line
  const [causaStateUpdate, setCausaStateUpdate] = useState({});
  const [updateCausa, setUpdateCausa] = useState(false);
  const [estadoCarga, setEstadoCargaa] = useState(false);
  const [persons, setPersons] = useState([]);
  const [receptors, setReceptors] = useState([]);
  const [notebooks, setNotebooks] = useState([]);
  const [currentNotebook, setCurrentNotebook] = useState(null);
  const [subStages, setSubStages] = useState([]);
  const [initialEditItem, setInitialEditItem] = useState({});

  const [isLoading, setIsLoading] = useState(false);

  const [updated, setUpdated] = useState(false);

  const [currentCollId, setCurrentCollId] = useState(null);
  const [debts, setDebts] = useState([]);

  let normalizarTexto = (texto) => {
    if (texto.type === "string") {
      texto = texto.toLowerCase();
      return texto.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    } else {
      return texto;
    }
  };
  //

  // Receptores: usados específicamente en el modal de Costas como "Persona Asociada".
  // Endpoint dedicado para no acoplar la lista filtrada al fetch general de persons,
  // que se usa en otros módulos sin filtrar.
  useEffect(() => {
    fetch(Parametros.urlApi + "persons/receptors", {
      headers: {
        Authorization: "Bearer " + usuario.key,
        Accept: "application/json",
      },
    })
      .then((res) => (res.ok ? res.json() : []))
      .then((data) => setReceptors(Array.isArray(data) ? data : []))
      .catch(() => setReceptors([]));
  }, [usuario.key]);

  useEffect(() => {
    fetch(Parametros.urlApi + "expense_factura_status_types", {
      headers: {
        Authorization: "Bearer " + usuario.key,
        Accept: "application/json",
      },
    })
      .then((res) => (res.ok ? res.json() : []))
      .then((data) =>
        setFacturaStatusTypes(Array.isArray(data) ? data : [])
      )
      .catch(() => setFacturaStatusTypes([]));
  }, [usuario.key]);

  useEffect(() => {
    if (currentNotebook) {
      setEstadoCargaa(true);
      fetch(
        Parametros.post +
          "coll_proc/stages?coll_proc_id=" +
          currentCollId +
          "&notebook_id=" +
          currentNotebook.value,
        {
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      )
        .then((res) => res.json())
        .then((data) => setstages(data))
        .finally(() => setEstadoCargaa(false));
    }
  }, [currentNotebook, currentCollId, usuario.key]);

  let getModules = async (modulo, id) => {
    setEstadoCargaa(true);

    if (modulo === "Historial") {
      await handleGetModuleHistorial();
    }

    try {
      if (modulo === "Etapas") {
        await Promise.all([
          fetch(Parametros.post + "notebooks", {
            headers: {
              Authorization: "Bearer " + usuario.key,
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }),
          fetch(Parametros.post + "substages", {
            headers: {
              Authorization: "Bearer " + usuario.key,
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }),
        ])
          .then(
            async (results) =>
              await Promise.all(results.map((response) => response.json()))
          )
          .then((responses) => {
            const setter = {
              0: (json) => {
                setNotebooks(json);
                const principal = json?.find((n) => n.name === PRINCIPAL_NOTEBOOK_NAME);
                setCurrentNotebook({
                  value: principal?.notebook_id,
                  label: principal?.name,
                });
              },
              1: setSubStages,
            };

            responses.forEach((jsonResult, idx) => {
              setter[idx](jsonResult);
            });
          })
          .finally(() => {
            setEstadoCargaa(false);
          });
      }
      if (modulo === "Estados") {
        await handleGetModuleEstados();
      }
      if (modulo === "Pagos") {
        await handleGetModulePagos();
      }
      if (modulo === "Títulos" || modulo === "Titulos") {
        await handleGetModuleTitulos();
      }
      if (modulo === "Bienes") {
        await handleGetModuleBienes();
      }
      if (modulo === "Contactos") {
        await handleGetModuleContactos();
      }
      if (modulo === "Direcciones") {
        await handleGetModuleDirecciones();
      }
      if (modulo === "Gastos Normales") {
        await handleGetModuleGastos();
      }
    } catch {}
  };

  const handleGetModuleEstados = async () => {
    let response = await fetch(
      Parametros.post + "coll_proc/states?coll_proc_id=" + id,
      {
        headers: {
          Authorization: "Bearer " + usuario.key,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    let responseJSON = await response.json();

    if (response.status === 200) {
      setstates(responseJSON);
      setEstadoCargaa(false);
    } else if (response.status === Parametros.loginTokenExcept) {
      alert(Parametros.loginTokenExceptMessage);
      history.push({
        pathname: "/",
      });
      return response.json();
    } else {
      alert(responseJSON.detail + " estados");
    }
  };
  const handleGetModuleHistorial = async () => {
    let response = await fetch(
      Parametros.post + "coll_proc/histories?coll_proc_id=" + id,
      {
        headers: {
          Authorization: "Bearer " + usuario.key,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );

    let responseJSON = await response.json();

    if (response.status === 200) {
      sethistories(responseJSON);
      setEstadoCargaa(false);
    } else if (response.status === Parametros.loginTokenExcept) {
      alert(Parametros.loginTokenExceptMessage);
      history.push({
        pathname: "/",
      });
    } else {
      alert(responseJSON.detail + " historial");
    }
  };
  const handleGetModuleDirecciones = async () => {
    let response = await fetch(
      Parametros.post + "coll_proc/address?coll_proc_id=" + id,
      {
        headers: {
          Authorization: "Bearer " + usuario.key,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    let responseJSON = await response.json();

    if (response.status === 200) {
      setaddress(responseJSON.data);
      setEstadoCargaa(false);
    } else if (response.status === Parametros.loginTokenExcept) {
      alert(Parametros.loginTokenExceptMessage);
      history.push({
        pathname: "/",
      });
    } else {
      alert(responseJSON.detail + " direcciones");
    }
  };
  const handleGetModuleContactos = async () => {
    let response = await fetch(
      Parametros.post + "coll_proc/contacts?coll_proc_id=" + id,
      {
        headers: {
          Authorization: "Bearer " + usuario.key,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    let responseJSON = await response.json();

    if (response.status === 200) {
      setcontacts(responseJSON.data);
      setEstadoCargaa(false);
    } else if (response.status === Parametros.loginTokenExcept) {
      alert(Parametros.loginTokenExceptMessage);
      history.push({
        pathname: "/",
      });
      return response.json();
    } else {
      alert(responseJSON.detail + " contactos");
    }
  };
  const handleGetModuleBienes = async () => {
    let response = await fetch(
      Parametros.post + "coll_proc/assets?coll_proc_id=" + id,
      {
        headers: {
          Authorization: "Bearer " + usuario.key,
          Accept: "application/json",
          "Content-Type": "application/json",
          Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
        },
      }
    );
    let responseJSON = await response.json();

    if (response.status === 200) {
      setBienes(responseJSON.data);
      setEstadoCargaa(false);
    } else if (response.status === Parametros.loginTokenExcept) {
      alert(Parametros.loginTokenExceptMessage);
      history.push({
        pathname: "/",
      });
      return response.json();
    } else {
      alert(responseJSON.detail + " bienes");
    }
  };
  const handleGetModuleTitulos = async () => {
    let response = await fetch(
      Parametros.post + "coll_proc/debt_titles?coll_proc_id=" + id,
      {
        headers: {
          Authorization: "Bearer " + usuario.key,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    let responseJSON = await response.json();

    if (response.status === 200) {
      setdebt_titles(responseJSON.data);

      setEstadoCargaa(false);
    } else if (response.status === Parametros.loginTokenExcept) {
      alert(Parametros.loginTokenExceptMessage);
      history.push({
        pathname: "/",
      });
      return response.json();
    } else {
      alert(responseJSON.detail + " titulos");
    }

    fetch(Parametros.urlApi + "coll_proc/debts/" + currentCollId, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + usuario.key,
        Accept: "application/json",
        "Content-Type": "application/json",
        Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
      },
    })
      .then((res) => res.json())
      .then((data) => setDebts(data));

    fetch(
      Parametros.urlApi +
        "coll_process/debt_amount?coll_proc_id=" +
        currentCollId,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + usuario.key,
          Accept: "application/json",
          "Content-Type": "application/json",
          Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        setCausaState((prev) => ({
          ...prev,
          deudaOriginal: data.original_debt,
          montoDeuda: data.total,
        }));
        setCausaStateUpdate((prev) => ({
          ...prev,
          deudaOriginal: data.original_debt,
          montoDeuda: data.total,
        }));
      });
  };
  const handleGetModuleGastos = async () => {
    let response = await fetch(
      Parametros.post + "coll_proc/expenses?coll_proc_id=" + id,
      {
        headers: {
          Authorization: "Bearer " + usuario.key,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    let responseJSON = await response.json();

    if (response.status === 200) {
      setexpenses(responseJSON);
      setEstadoCargaa(false);
    } else if (response.status === Parametros.loginTokenExcept) {
      alert(Parametros.loginTokenExceptMessage);
      history.push({
        pathname: "/",
      });
    } else {
      alert(responseJSON.detail + " gastos");
    }
  };
  const handleGetModulePagos = async () => {
    let response = await fetch(
      Parametros.post + "coll_proc/payments?coll_proc_id=" + id,
      {
        headers: {
          Authorization: "Bearer " + usuario.key,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    let responseJSON = await response.json();

    if (response.status === 200) {
      setpayments(responseJSON.data);
      setEstadoCargaa(false);
    } else if (response.status === Parametros.loginTokenExcept) {
      alert(Parametros.loginTokenExceptMessage);
      history.push({
        pathname: "/",
      });
      return response.json();
    } else {
      alert(responseJSON.detail + " pagos");
    }
  };

  // eslint-disable-next-line
  useEffect(() => {
    setIsLoading(true);
    fetch(Parametros.urlApi + "coll_process/" + id, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + usuario.key,
        Accept: "application/json",
        "Content-Type": "application/json",
        Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((jsonResult) => {
        fetch(
          Parametros.urlApi +
            "coll_process/debt_amount?coll_proc_id=" +
            jsonResult.coll_proc_id,
          {
            method: "GET",
            headers: {
              Authorization: "Bearer " + usuario.key,
              Accept: "application/json",
              "Content-Type": "application/json",
              Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
            },
          }
        )
          .then((response) => response.json())
          .then((data) => {
            jsonResult.montoDeuda = data.total;
            jsonResult.monedaDeuda = data.currency;
            jsonResult.deudaOriginal = data.original_debt;
            setCausaState(JSON.parse(JSON.stringify(jsonResult)));
            setCausaStateUpdate(JSON.parse(JSON.stringify(jsonResult)));
            getModules(usuario.modulos[0], jsonResult.coll_proc_id);
            setCurrentCollId(jsonResult.coll_proc_id);
          })
          .finally(() => {
            setIsLoading(false);
          });
      });

    // eslint-disable-next-line
  }, [updateCausa, usuario]);

  useEffect(() => {
    try {
      setIsLoading(true);
      Promise.all([
        fetch(Parametros.urlApi + "coll_process/" + id, {
          method: "GET",
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        }),
        fetch(Parametros.urlApi + "process_types?skip=0&limit=100", {
          method: "GET",
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        }),
        fetch(Parametros.urlApi + "companies", {
          method: "GET",
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        }),
        fetch(Parametros.urlApi + "countries?skip=0&limit=100", {
          method: "GET",
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        }),
        fetch(Parametros.urlApi + "courts", {
          method: "GET",
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        }),
        fetch(Parametros.urlApi + "court_roles?skip=0&limit=100", {
          method: "GET",
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        }),
        fetch(Parametros.urlApi + "stages?&limit=5000", {
          method: "GET",
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        }),
        fetch(Parametros.urlApi + "Currency?skip=0&limit=100 ", {
          method: "GET",
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        }),
        fetch(Parametros.urlApi + "states?skip=0&limit=100 ", {
          method: "GET",
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        }),
        fetch(Parametros.urlApi + "debt_concepts?skip=0&limit=100 ", {
          method: "GET",
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        }),
        fetch(Parametros.urlApi + "asset_types?skip=0&limit=100", {
          method: "GET",
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        }),
        fetch(Parametros.urlApi + "origins?skip=0&limit=100", {
          method: "GET",
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        }),
        fetch(Parametros.urlApi + "contacsTypes?skip=0&limit=100", {
          method: "GET",
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        }),
        fetch(Parametros.urlApi + "contacsClass?skip=0&limit=100", {
          method: "GET",
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        }),
        fetch(Parametros.urlApi + "address_units?skip=0&limit=100", {
          method: "GET",
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        }),
        fetch(Parametros.urlApi + "address_types?skip=0&limit=100", {
          method: "GET",
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        }),
        fetch(Parametros.urlApi + "debt_title_types?skip=0&limit=100", {
          method: "GET",
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        }),
        fetch(Parametros.urlApi + "debt_concepts?skip=0&limit=100", {
          method: "GET",
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        }),
        fetch(Parametros.urlApi + "expense_concepts", {
          method: "GET",
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        }),
        fetch(Parametros.urlApi + "coll_proc_results", {
          method: "GET",
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        }),
        fetch(Parametros.urlApi + "coll_action_types", {
          method: "GET",
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        }),
        fetch(Parametros.urlApi + "geoadmin", {
          method: "GET",
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        }),
        fetch(Parametros.urlApi + "address", {
          method: "GET",
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        }),
        fetch(Parametros.urlApi + "debts", {
          method: "GET",
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        }),
        fetch(Parametros.urlApi + "persons?limit=10000", {
          method: "POST",
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
          body: JSON.stringify({
            first_name: "",
            full_name: "",
            last_name_1: "",
            legal_id: "",
            legal_id_type: "",
          }),
        }),
        fetch(Parametros.urlApi + "portfolios?skip=0&limit=1000", {
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        }),
      ])
        .then(async (results) => {
          return await Promise.all(results.map((response) => response.json()));
        })
        .then((results, idx) => {
          const setter = {
            1: settipoProceso,
            2: setAcreedores,
            3: setPaises,
            4: setTribunales,
            5: setRolTribunal,
            6: setEtapas,
            7: setMonedas,
            8: setEstados,
            9: setConceptosDeudasState,
            10: setTiposActivos,
            11: setOrigenDatosState,
            12: setTipoContactoState,
            13: setClaseContactoState,
            14: setDireccion_unit,
            15: setTipoDireccion,
            16: setTitulos,
            17: setConceptosDeudasState,
            18: setExpenseConceptState,
            19: setCallActionsResult,
            20: setCollActionTypeState,
            21: setGeoAdminState,
            22: setDireccionState,
            23: setDeudoresState,
            24: setPersons,
            25: setPortfolios,
          };

          results.forEach((jsonResult, idx) => {
            if (idx === 0) {
              fetch(
                Parametros.urlApi +
                  "coll_process/debt_amount?coll_proc_id=" +
                  jsonResult.coll_proc_id,
                {
                  method: "GET",
                  headers: {
                    Authorization: "Bearer " + usuario.key,
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
                  },
                }
              )
                .then((response) => response.json())
                .then((data) => {
                  jsonResult.montoDeuda = data.total;
                  jsonResult.monedaDeuda = data.currency;
                  jsonResult.deudaOriginal = data.original_debt;
                  setCausaState(JSON.parse(JSON.stringify(jsonResult)));
                  setCausaStateUpdate(JSON.parse(JSON.stringify(jsonResult)));
                  // getModules(usuario.modulos[0], ...) fue removido de acá:
                  // el primer useEffect que carga la causa ya lo llama, y
                  // duplicarlo hacía que el modulo default se cargara dos
                  // veces (parpadeo/leve recarga al abrir Administrar Causa).
                  setCurrentCollId(jsonResult.coll_proc_id);
                })
                .finally(() => {
                  setIsLoading(false);
                });
            }
            if (idx !== 0) {
              if (idx === 6 || idx === 24) {
                setter[idx](jsonResult.data);
              } else {
                setter[idx](jsonResult);
              }
            }
          });
        });
    } catch {}

    var i, tablinks;
    tablinks = document.getElementsByClassName("tablinks");
    // if(usuario.modulos.length >= 0 ){
    //
    // }
    for (i = 0; i < tablinks.length; i++) {
      if (usuario.modulos.includes(tablinks[i].innerHTML)) {
        if (tablinks[i].innerHTML === usuario.modulos[0]) {
          tablinks[i].className = "tablinks active";
          document.getElementById(tablinks[i].innerHTML).style.display =
            "block";
        }
      } else {
        tablinks[i].className = "botonDisable tablinks";
      }
    }
    // llamadaApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [usuario, storage]);
  const [update, setStateUpdate] = useState([]);
  const [controlState, setControlState] = useState({});

  const [editable, setEditable] = useState({
    id: "",
  });
  const [etapas, setEtapas] = useState([]);
  const [monedas, setMonedas] = useState([]);
  const [estados, setEstados] = useState([]);
  const [tipoActivosState, setTiposActivos] = useState([]);
  const [origenDatosState, setOrigenDatosState] = useState([]);
  const [tipoContactoState, setTipoContactoState] = useState([]);
  const [claseContactoState, setClaseContactoState] = useState([]);
  const [tipoProceso, settipoProceso] = useState([]);
  //
  const [titulosState, setTitulos] = useState([]);
  // eslint-disable-next-line
  const [rolTribunal, setRolTribunal] = useState([]);
  const [tribunales, setTribunales] = useState([]);
  // eslint-disable-next-line
  const [deudoresState, setDeudoresState] = useState([]);
  const [expensConceptState, setExpenseConceptState] = useState([]);
  const [facturaStatusTypes, setFacturaStatusTypes] = useState([]);
  const [callActionsResultState, setCallActionsResult] = useState([]);
  const [collActionTypeState, setCollActionTypeState] = useState([]);
  const [direccionState, setDireccionState] = useState([]);
  const [geoAdminState, setGeoAdminState] = useState([]);
  const [direccion_unit, setDireccion_unit] = useState([]);
  const [tipoDireccion, setTipoDireccion] = useState([]);
  const [paises, setPaises] = useState([]);
  const [conceptoDeudaState, setConceptosDeudasState] = useState([]);
  const [acreedores, setAcreedores] = useState([]);
  const [portfolios, setPortfolios] = useState([]);

  let getCountry = (idCountry) => {
    const countryItem = paises.find(
      (pais) => pais.country_id === idCountry
    );
    if (!countryItem) return "Desconocido";
    return countryItem.alias;
  };

  let getGeoadminValue = (idGeo) => {
    const geoItem = geoAdminState.find(
      (geo) => geo.geoadmin_zone_id === idGeo
    );
    if (!geoItem) return "No disponible";
    return (
      getCountry(geoItem.country) +
      " | " +
      geoItem.geoadmin1 +
      " | " +
      geoItem.geoadmin2 +
      " | " +
      geoItem.geoadmin3
    );
  };

  const [stagesState, setstages] = useState([]);
  const [formularioStateStage, setFormularioStateStage] = useState({
    comment: "",
    stage: "",
    startdate: "",
    associated_person: null,
    parent_stage: "",
    // user_email: usuario.email
  });
  let crearEtapa = (event) => {
    event.preventDefault();

    if (window.confirm("¿Esta seguro que deseas agregar este elemento?")) {
      // aqui deberia ir el delete segun response eliminar de la lista de react

      let formularioEtapa = JSON.parse(JSON.stringify(formularioStateStage));

      etapas.map((item) => {
        if (item.name === formularioEtapa.stage) {
          formularioEtapa.stage = item.stage_id;
        }
        return item;
      });

      formularioEtapa.collproc = causaState.coll_proc_id;

      let status = 0;

      fetch(Parametros.post + "coll_proc/stages", {
        method: "POST",
        body: JSON.stringify(formularioEtapa),
        headers: {
          Authorization: "Bearer " + usuario.key,
          Accept: "application/json",
          "Content-Type": "application/json",
          Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
        },
      })
        .then((response) => {
          status = response.status;
          return response.json();
        })
        .then((data) => {
          if (status === 200) {
            alert(data?.message);
            setIsOpen("");
            getModules(event.target.form.id, causaState.coll_proc_id);
            setUpdateCausa((prev) => !prev);
          } else if (status === 422) {
            alert(data?.detail?.[0]?.msg);
          } else {
            alert(data?.detail);
          }
          event.target.form.reset();
        });
    } else {
      // Do nothing!
      // setEditable({})
      // setpersonaEmpresaState(JSON.parse(JSON.stringify(personaEmpresaStateUpdate)))
      event.target.form.reset();
    }

    setIsOpen("");
  };

  const [statesState, setstates] = useState([]);
  const [formularioStateState, setFormularioStateState] = useState({
    startdate: "",
    state: "",
  });
  let crearEstado = (event) => {
    event.preventDefault();

    if (window.confirm("¿Esta seguro que deseas agregar este elemento?")) {
      // aqui deberia ir el delete segun response eliminar de la lista de react

      let formulario = JSON.parse(JSON.stringify(formularioStateState));
      estados.map((item) => {
        if (item.name === formulario.state) {
          formulario.state = item.state_id;
        }
        return item;
      });
      formulario.collproc = causaState.coll_proc_id;
      let status = 0;

      fetch(Parametros.post + "coll_proc/state", {
        method: "POST",
        body: JSON.stringify(formulario),
        headers: {
          Authorization: "Bearer " + usuario.key,
          Accept: "application/json",
          "Content-Type": "application/json",
          Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
        },
      })
        .then((response) => {
          status = response.status;
          return response.json();
        })
        .then((data) => {
          if (status === 200) {
            alert(data?.message);
            setIsOpen("");
            getModules(event.target.form.id, causaState.coll_proc_id);
            setUpdateCausa((prev) => !prev);
          } else if (status === 422) {
            alert(data?.detail?.[0]?.msg);
          } else {
            alert(data?.detail);
          }
          event.target.form.reset();
        });
    } else {
      // Do nothing!
      event.target.form.reset();
    }

    setIsOpen("");
  };

  const [paymentsState, setpayments] = useState([]);
  const [formularioStatePayments, setFormularioStatePayments] = useState({
    currency: "",
    date: "",
    debt: "",
    amount: "",
    collproc: "",
    description: "",

    // user_email: usuario.email
  });
  let crearPago = (event) => {
    event.preventDefault();

    if (window.confirm("¿Esta seguro que deseas agregar este elemento?")) {
      // aqui deberia ir el delete segun response eliminar de la lista de react

      let formulario = JSON.parse(JSON.stringify(formularioStatePayments));

      formulario.amount = parseInt(formulario.amount);

      monedas.map((item) => {
        if (item.isocode === formulario.currency) {
          formulario.currency = item.currency_id;
        }
        return item;
      });

      formulario.collproc = Number(id);

      let status = 0;

      fetch(Parametros.post + "coll_proc/payment", {
        method: "POST",
        body: JSON.stringify(formulario),
        headers: {
          Authorization: "Bearer " + usuario.key,
          Accept: "application/json",
          "Content-Type": "application/json",
          Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
        },
      })
        .then((response) => {
          status = response.status;
          return response.json();
        })
        .then((data) => {
          if (status === 200) {
            alert(data?.message);
            setIsOpen("");
            getModules(event.target.form.id, causaState.coll_proc_id);
            setUpdateCausa((prev) => !prev);
          } else if (status === 422) {
            alert(data?.detail?.[0]?.msg);
          } else {
            alert(data?.detail);
          }
          event.target.form.reset();
        });
    } else {
      // Do nothing!
      event.target.form.reset();
    }

    setIsOpen(false);
  };

  const [expensesState, setexpenses] = useState([]);
  const [formularioStateExpenses, setFormularioStateExpenses] = useState({
    date: "",
    description: "",
    amount: "",
    concept: "",
    currency: "",
    // user_email: usuario.email
  });
  const resetFormularioExpenses = () => {
    setFormularioStateExpenses({
      date: "",
      description: "",
      amount: "",
      concept: "",
      currency: "",
    });
  };

  let crearGasto = (event) => {
    event.preventDefault();
    for (const key in formularioStateExpenses) {
      if (formularioStateExpenses[key] === "") {
        alert("Todos los campos son obligatorios");
        return;
      }
    }
    if (window.confirm("¿Esta seguro que deseas agregar este elemento?")) {
      // aqui deberia ir el delete segun response eliminar de la lista de react

      let formulario = JSON.parse(JSON.stringify(formularioStateExpenses));

      monedas.map((item) => {
        if (item.isocode === formulario.currency) {
          formulario.currency = item.currency_id;
        }
        return item;
      });

      expensConceptState.map((item) => {
        if (item.name === formulario.concept) {
          formulario.concept = item.concept_id;
        }
        return item;
      });

      formulario.collproc = causaState.coll_proc_id;
      formulario.amount = parseInt(formulario.amount);

      let status = 0;

      fetch(Parametros.post + "coll_proc/expense", {
        method: "POST",
        body: JSON.stringify(formulario),
        headers: {
          Authorization: "Bearer " + usuario.key,
          Accept: "application/json",
          "Content-Type": "application/json",
          Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
        },
      })
        .then((response) => {
          status = response.status;
        })
        .then((data) => {
          if (status === 200) {
            setIsOpen("");
            getModules(event.target.form.id, causaState.coll_proc_id);
            event.target.form.reset();
            resetFormularioExpenses();
            alert("Gasto creado con exito");
          } else if (status === 422) {
            alert(data?.detail[0]?.msg);
          } else {
            console.log(data);
            alert(data?.detail);
          }
        });
    } else {
      event.target.form.reset();
      resetFormularioExpenses();
    }

    setIsOpen("");
  };

  const [debt_titlesState, setdebt_titles] = useState([]);
  const [formularioStateTitle, setFormularioStateTitle] = useState({
    type: "",
    origindate: "",
    duedate: "",
    debt: null,
    amount: 0,
    comment: "",
    currency: "",
  });
  let crearTitulo = (event) => {
    event.preventDefault();
    let formulario = JSON.parse(JSON.stringify(formularioStateTitle));
    const notRequiredKeys = ["comment", "client_payment_id"];
    for (const key in formulario) {
      if (!formulario[key] && !notRequiredKeys.includes(key)) {
        alert("Complete los campos obligatorios");
        return;
      }
    }
    if (window.confirm("¿Esta seguro que deseas agregar este elemento?")) {
      // aqui deberia ir el delete segun response eliminar de la lista de react

      let status = 0;

      fetch(Parametros.post + "coll_proc/debt_title", {
        method: "POST",
        body: JSON.stringify(formulario),
        headers: {
          Authorization: "Bearer " + usuario.key,
          Accept: "application/json",
          "Content-Type": "application/json",
          Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
        },
      })
        .then((response) => {
          status = response.status;
          if (response.status === 200 || response.status === 201) {
            return response.json();
          } else if (response.status === Parametros.loginTokenExcept) {
            alert(Parametros.loginTokenExceptMessage);
            history.push({
              pathname: "/",
            });
          }
        })
        .then((data) => {
          if (status === 200) {
            setFormularioStateTitle({
              type: "",
              origindate: "",
              duedate: "",
              debt: null,
              amount: 0,
              comment: "",
              currency: "",
            });
            alert(data?.message);
            setIsOpen("");
            getModules(event.target.form.id, causaState.coll_proc_id);
            event.target.form.reset();
          } else if (status === 422) {
            alert(data?.detail?.[0]?.msg);
          } else {
            alert(data?.detail);
          }
        });
    } else {
      // Do nothing!
      // event.target.form.reset();
    }
  };

  const [bienesState, setBienes] = useState([]);
  const [formularioStateBienes, setFormularioStateBienes] = useState({
    typeAsset: "",
    value: "",
    description: "",
    location: "",
    isActive: true,
    currencyId: "",
    owner: null,
    tenant: null,
    dataorigin: "",
    score: 0,
    infodate: "",
    // user_email: usuario.email
  });
  let crearBienes = (event) => {
    event.preventDefault();
    if (window.confirm("¿Esta seguro que deseas agregar este elemento?")) {
      // aqui deberia ir el delete segun response eliminar de la lista de react

      let formulario = JSON.parse(JSON.stringify(formularioStateBienes));

      formulario.value = parseInt(formulario?.value);

      let status = 0;

      fetch(Parametros.post + "coll_proc/asset", {
        method: "POST",
        body: JSON.stringify(formulario),
        headers: {
          Authorization: "Bearer " + usuario.key,
          Accept: "application/json",
          "Content-Type": "application/json",
          Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
        },
      })
        .then((response) => {
          status = response.status;

          if (response.status === Parametros.loginTokenExcept) {
            alert(Parametros.loginTokenExceptMessage);
            history.push({
              pathname: "/",
            });
          }

          return response.json();
        })
        .then((data) => {
          if (status === 200) {
            alert(data?.message);
            setIsOpen("");
            getModules(event.target.form.id, causaState.coll_proc_id);
          } else if (status === 422) {
            alert(data?.detail?.[0]?.msg);
          } else {
            alert(data?.detail);
          }
          event.target.form.reset();
        });
    } else {
      // Do nothing!
      event.target.form.reset();
    }

    setIsOpen("");
  };

  const [contactsState, setcontacts] = useState([]);
  const [formularioStateContacto, setFormularioStateContacto] = useState({
    infodate: "",
    contactclass: "",
    contacttype: "",
    score: 0,
    is_active: false,
    person: "",
    additional_info: "",
    dataorigin: "",
    value: "",
  });
  let crearContacto = (event) => {
    event.preventDefault();

    if (window.confirm("¿Esta seguro que deseas agregar este elemento?")) {
      // aqui deberia ir el delete segun response eliminar de la lista de react

      let formulario = JSON.parse(JSON.stringify(formularioStateContacto));

      formulario.person = contactsState[0].person_id;
      formulario.score = parseInt(formulario.score);

      let status = 0;

      fetch(Parametros.post + "coll_proc/contact", {
        method: "POST",
        body: JSON.stringify(formulario),
        headers: {
          Authorization: "Bearer " + usuario.key,
          Accept: "application/json",
          "Content-Type": "application/json",
          Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
        },
      })
        .then((response) => {
          status = response.status;
          if (response.status === 200 || response.status === 201) {
            return response.json();
          } else if (response.status === Parametros.loginTokenExcept) {
            alert(Parametros.loginTokenExceptMessage);
            history.push({
              pathname: "/",
            });
          }
        })
        .then((data) => {
          if (status === 200) {
            alert(data?.message);
            setIsOpen("");
            getModules(event.target.form.id, causaState.coll_proc_id);
            setStateUpdate([]);
            setformularioUpdate({});

            event.target.form.reset();
          } else if (status === 422) {
            alert(data?.detail?.[0]?.msg);
          } else {
            alert(data?.detail);
          }
        });
    } else {
      // Do nothing!
      event.target.form.reset();
    }

    setIsOpen("");
  };

  const [historiesState, sethistories] = useState([]);
  const [formularioStateHistorial, setFormularioStateHistorial] = useState({
    type: "",
    details: "",
    collproc: 0,
    result: "",
    agent: 43,
  });
  let crearHistorial = (event) => {
    event.preventDefault();
    let isCompleted = true;
    for (const key in formularioStateHistorial) {
      if (formularioStateHistorial[key] === "") {
        isCompleted = false;
      }
    }
    if (!isCompleted) {
      return alert("Debe completar todos los campos");
    }
    if (window.confirm("¿Esta seguro que deseas agregar este elemento?")) {
      // aqui deberia ir el delete segun response eliminar de la lista de react

      let formulario = JSON.parse(JSON.stringify(formularioStateHistorial));
      formulario.collproc = parseInt(causaState.coll_proc_id);

      callActionsResultState.map((itemFilter) => {
        if (
          normalizarTexto(itemFilter.name) ===
          normalizarTexto(formulario.result)
        ) {
          formulario.result = itemFilter.call_action_result_id;
        }
        return itemFilter;
      });

      collActionTypeState.map((itemFilter) => {
        if (
          normalizarTexto(itemFilter.name) === normalizarTexto(formulario.type)
        ) {
          formulario.type = itemFilter.call_action_type_id;
        }
        return itemFilter;
      });

      let status = 0;

      fetch(Parametros.post + "coll_proc/history", {
        method: "POST",
        body: JSON.stringify(formulario),
        headers: {
          Authorization: "Bearer " + usuario.key,
          Accept: "application/json",
          "Content-Type": "application/json",
          Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
        },
      })
        .then((response) => {
          status = response.status;
          if (response.status === 200 || response.status === 201) {
            return response.json();
          } else if (response.status === Parametros.loginTokenExcept) {
            alert(Parametros.loginTokenExceptMessage);
            history.push({
              pathname: "/",
            });
          }
        })
        .then((data) => {
          if (status === 200) {
            alert(data?.message);
            setIsOpen("");
            getModules(event.target.form.id, causaState.coll_proc_id);
            event.target.form.reset();
          } else if (status === 422) {
            alert(data?.detail?.[0]?.msg);
          } else {
            alert(data?.detail);
          }
        });
    } else {
      // Do nothing!
      event.target.form.reset();
    }

    setIsOpen("");
  };

  const [addressState, setaddress] = useState([]);
  const [formularioAddressState, setFormularioAddressState] = useState({
    person: "",
    address_type: "",
    infodate: "2022-05-31",
    is_active: true,
    is_blocked: false,
    address: "",
    dataorigin: "",
    address_unit: "",
    score: 0,
  });
  let crearDireccion = (event) => {
    event.preventDefault();
    if (window.confirm("¿Esta seguro que deseas agregar este elemento?")) {
      // aqui deberia ir el delete segun response eliminar de la lista de react

      let formulario = JSON.parse(JSON.stringify(formularioAddressState));
      formulario.person = addressState[0].person_id;
      formulario.collproc = causaState.coll_proc_id;

      let status = 0;

      fetch(Parametros.post + "coll_proc/address", {
        method: "POST",
        body: JSON.stringify(formulario),
        headers: {
          Authorization: "Bearer " + usuario.key,
          Accept: "application/json",
          "Content-Type": "application/json",
          Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
        },
      })
        .then(async (response) => {
          status = response.status;
          if (response.status === Parametros.loginTokenExcept) {
            alert(Parametros.loginTokenExceptMessage);
            history.push({ pathname: "/" });
            return null;
          }
          try {
            return await response.json();
          } catch {
            return null;
          }
        })
        .then((data) => {
          if (status === 200 || status === 201) {
            alert(data?.message || "Dirección creada");
            setIsOpen("");
            getModules(event.target.form.id, causaState.coll_proc_id);
            event.target.form.reset();
          } else if (status === 422) {
            const first = data?.detail?.[0];
            const loc = first?.loc ? ` (${first.loc.slice(1).join(".")})` : "";
            alert((first?.msg || "Datos inválidos") + loc);
            console.error("422 detail:", data?.detail);
          } else {
            alert(data?.detail || `Error ${status}`);
          }
        });
    } else {
      // Do nothing!
      event.target.form.reset();
    }

    setIsOpen("");
  };
  const [col_procDebt, setCol_procDebt] = useState([]);
  const [formularioColl_col_procDebt, setFormularioColl_col_procDebt] =
    useState({
      collproc: 0,
      concept: 0,
      description: "",
      amount: 0,
      date: "",
      period: "",
      creditor: 0,
      debtor: 0,
      currency_id: 0,
    });
  let crearCollDebt = (event) => {
    event.preventDefault();
    if (window.confirm("¿Esta seguro que deseas agregar este elemento?")) {
      // aqui deberia ir el delete segun response eliminar de la lista de react

      let formulario = JSON.parse(JSON.stringify(formularioColl_col_procDebt));
      // formulario.person = addressState[0].person_id

      let status = 0;

      fetch(Parametros.post + "coll_proc_debt/" + causaState.coll_proc_id, {
        method: "POST",
        body: JSON.stringify(formularioColl_col_procDebt),
        headers: {
          Authorization: "Bearer " + usuario.key,
          Accept: "application/json",
          "Content-Type": "application/json",
          Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
        },
      })
        .then((response) => {
          status = response.status;
          if (response.status === 200 || response.status === 201) {
            return response.json();
          } else if (response.status === Parametros.loginTokenExcept) {
            alert(Parametros.loginTokenExceptMessage);
            history.push({
              pathname: "/",
            });
          }
        })
        .then((data) => {
          if (status === 200) {
            alert(data?.message);
            setIsOpen("");
            getModules(event.target.form.id, causaState.coll_proc_id);
            event.target.form.reset();
          } else if (status === 422) {
            alert(data?.detail?.[0]?.msg);
          } else {
            alert(data?.detail);
          }
        });
    } else {
      // Do nothing!
      event.target.form.reset();
    }

    setIsOpen("");
  };

  const [coll_proc_Tribunal, setColl_proc_Tribunal] = useState([]);
  const [formularioColl_proc_Tribunal, setFormularioColl_proc_Tribunal] =
    useState({
      collproc: 0,
      court: 0,
      role: 0,
      legalprocessid: "",
    });
  let crearCollprocTribunal = (event) => {
    event.preventDefault();
    if (window.confirm("¿Esta seguro que deseas agregar este elemento?")) {
      // aqui deberia ir el delete segun response eliminar de la lista de react

      // formulario.person = addressState[0].person_id

      let status = 0;
      formularioColl_proc_Tribunal.collproc = causaState.coll_proc_id;
      console.log(formularioColl_proc_Tribunal);
      fetch(Parametros.post + "coll_proc_court/", {
        method: "POST",
        body: JSON.stringify(formularioColl_proc_Tribunal),
        headers: {
          Authorization: "Bearer " + usuario.key,
          Accept: "application/json",
          "Content-Type": "application/json",
          Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
        },
      })
        .then((response) => {
          status = response.status;
          if (response.status === 200 || response.status === 201) {
            setUpdated(!updated);
            return response.json();
          } else if (response.status === Parametros.loginTokenExcept) {
            alert(Parametros.loginTokenExceptMessage);
            history.push({
              pathname: "/",
            });
          } else {
            return response.json();
          }
        })
        .then((data) => {
          if (status === 200) {
            alert("ok");
            setIsOpen("");
            event.target.form.reset();
            setUpdateCausa(!updateCausa);
          } else if (status === 422) {
            alert(data?.detail?.[0]?.msg);
          } else {
            alert(data?.detail);
          }
        });
    } else {
      // Do nothing!
      event.target.form.reset();
    }

    setIsOpen("");
  };

  const [coll_proc_Category, setColl_proc_Category] = useState([]);
  const [formDebtCategory, setFormDebtCategory] = useState({
    debt_id: "",
    category: "",
    category_id: "",
  });
  const [formularioColl_proc_Category, setFormularioColl_proc_Category] =
    useState({
      collproc: 0,
      court: 0,
      role: 0,
      legalprocessid: "",
    });
  let crearCollprocCategory = (event) => {
    event.preventDefault();
    if (window.confirm("¿Esta seguro que deseas agregar este elemento?")) {
      // aqui deberia ir el delete segun response eliminar de la lista de react

      // formulario.person = addressState[0].person_id

      let status = 0;
      console.log({ causaState });

      let formToSend = {
        debt_id: Number(causaState.debt_id),
        category: formDebtCategory.category_id,
      };

      console.log({ formToSend });
      fetch(Parametros.post + "debt_category", {
        method: "POST",
        headers: {
          Authorization: "Bearer " + usuario.key,
          Accept: "application/json",
          "Content-Type": "application/json",
          Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
        },
        body: JSON.stringify(formToSend),
      })
        .then((response) => {
          status = response.status;
          if (response.status === 200 || response.status === 201) {
            return response.json();
          } else if (response.status === Parametros.loginTokenExcept) {
            alert(Parametros.loginTokenExceptMessage);
            history.push({
              pathname: "/",
            });
          } else {
            return response.json();
          }
        })
        .then((data) => {
          if (status === 200) {
            alert("ok");
            setIsOpen("");
            event.target.form.reset();
            setUpdateCausa(!updateCausa);
          } else if (status === 422) {
            alert(data?.detail?.[0]?.msg);
          } else {
            alert(data?.detail);
          }
        });
    } else {
      // Do nothing!
      event.target.form.reset();
    }

    setIsOpen("");
  };

  const [modalIsOpen, setIsOpen] = useState("");

  // Al abrir "Agregar Etapa" pre-cargamos:
  //  - stage: la sub etapa actual de la causa (para que el usuario solo tenga
  //    que confirmarla si es la misma, o cambiarla si corresponde).
  //  - startdate: la fecha de hoy (editable). El resto del formulario se
  //    conserva; al cerrar el modal quedaria con estos valores.
  useEffect(() => {
    if (modalIsOpen === "Etapas") {
      const today = new Date().toISOString().slice(0, 10);
      setFormularioStateStage((prev) => ({
        ...prev,
        stage: causaState?.stage_id || "",
        startdate: today,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalIsOpen, causaState?.stage_id]);

  const handleInputChangeCausa = (e) => {
    const target = e.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = e.target.getAttribute("name");

    setCausaState({
      ...causaState,
      [name]: value,
    });

    let estadoUpdate = formularioUpdate;
    estadoUpdate[name] = value;

    setformularioUpdate(JSON.parse(JSON.stringify(estadoUpdate)));
  };

  const [resetInput, setrestInput] = useState(false);

  let guardarCambios = () => {
    let newform = {
      type: formularioUpdate.tipo_causa,
      n_operation: formularioUpdate.n_operation,
      strategy: formularioUpdate.strategy,
      court: formularioUpdate.nombre_tribunal,
      court_role: formularioUpdate.rol_tribunal,
      legalprocessid: formularioUpdate.rol,
      rol_debt: formularioUpdate.rut_deudor
        ? formularioUpdate.rut_deudor.split("/")[0].split("-")[0]
        : undefined,
      debt_id: causaState.debt_id ? causaState.debt_id : undefined,
      category_id: formularioUpdate.categoryname,
      debtcategory_id: causaState.debtcategory_id
        ? causaState.debtcategory_id
        : null,
      portfolio: formularioUpdate.portfolio
        ? formularioUpdate.portfolio
        : undefined,
    };
    let statusCode = 0;
    fetch(Parametros.urlApi + "coll_proc/" + causaState.coll_proc_id, {
      method: "PUT",
      headers: {
        Authorization: "Bearer " + usuario.key,
        Accept: "application/json",
        "Content-Type": "application/json",
        Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
      },
      body: JSON.stringify(newform),
    })
      .then((data) => {
        statusCode = data.status;
        if (data.status === 200 || data.status === 201) {
          return data.json();
        } else if (data.status === Parametros.loginTokenExcept) {
          alert(Parametros.loginTokenExceptMessage);
          history.push({
            pathname: "/",
          });
          return data.json();
        } else {
          return data.json();
        }
      })
      .then((data) => {
        if (statusCode === 200) {
          alert(data?.message);

          setCausaStateUpdate(causaState);
          setStorage(!storage);
          setEditableCausa(!editableCausa);
          setrestInput(!resetInput);
          setUpdateCausa(!updateCausa);
        } else {
          alert(data?.detail);
        }
      });
  };

  let editarCusa = (editarState) => {
    if (editarState === true) {
      if (
        usuario.modulosAdministracion.indexOf("Causas") > -1 &&
        usuario.permisos.indexOf("Editar") > -1
      ) {
        setEditableCausa(editarState);
      } else {
        alert("no tiene permisos para editar la causa");
      }
    } else {
      setCausaState(JSON.parse(JSON.stringify(causaStateUpdate)));
      setEditableCausa(editarState);
      setformularioUpdate({});
    }
  };

  // exhortos: declarado acá porque `datosGenerales` (abajo) lo usa al
  // evaluarse; el resto de su CRUD vive más abajo en el componente.
  const [exhortos, setExhortos] = useState([]);

  let datosGenerales = (
    <div className="col-md-12 contenedorGrande">
      <h3 style={{ textAlign: "left" }}>Datos Generales</h3>

      {editableCausa === true ? (
        <>
          <button
            className="btn btn-primary"
            style={{ margin: "0px 20px" }}
            onClick={(e) => {
              editarCusa(false);
            }}
          >
            Deshacer
          </button>

          <button
            className="btn btn-primary"
            style={{ margin: "0px 20px" }}
            onClick={(e) => {
              guardarCambios();
            }}
          >
            Guardar
          </button>
        </>
      ) : (
        <>
          <button
            className="btn btn-primary"
            style={{ margin: "0px 20px" }}
            onClick={(e) => {
              editarCusa(true);
            }}
          >
            Editar
          </button>

          {!causaState.nombre_tribunal && (
            <>
              <button
                className="btn  btn-primary"
                style={{ margin: "0px 20px" }}
                onClick={(event) => controlForm("Tribunales")}
              >
                Agregar Tribunal
              </button>

              <FormularioModulos
                listax={rolTribunal.map((item) => {
                  return { value: item.court_role_id, label: item.name };
                })}
                listax2={tribunales.map((item) => {
                  return { value: item.court_id, label: item.name };
                })}
                modalIsOpen={modalIsOpen}
                setModalIsOpen={setIsOpen}
                modulo={"Tribunales"}
                crear={crearCollprocTribunal}
                formulario={formularioColl_proc_Tribunal}
                setFormulario={setFormularioColl_proc_Tribunal}
              ></FormularioModulos>
            </>
          )}
          {!causaState.rut_deudor && (
            <>
              <button
                className="btn  btn-primary"
                style={{ margin: "10px 20px" }}
                onClick={(event) => controlForm("Deudores")}
              >
                Agregar Deudor
              </button>

              <FormularioModulos
                listax={conceptoDeudaState.map((item) => {
                  return { value: item.debt_concept_id, label: item.name };
                })}
                listax2={acreedores.map((item) => {
                  return { value: item.rut, label: item.name + "/" + item.rut };
                })}
                listax3={acreedores.map((item) => {
                  return { value: item.court_role_id, label: item.name };
                })}
                listax4={monedas.map((item) => {
                  return { value: item.currency_id, label: item.isocode };
                })}
                modalIsOpen={modalIsOpen}
                setModalIsOpen={setIsOpen}
                modulo={"Deudores"}
                crear={crearCollDebt}
                formulario={formularioColl_col_procDebt}
                setFormulario={setFormularioColl_col_procDebt}
              ></FormularioModulos>
            </>
          )}
        </>
      )}

      <hr></hr>
      <div className="col-md-12">
        <h3>
          <b>Deuda original </b>
          {(causaState.deudaOriginal || 0).toLocaleString() +
            " " +
            causaState.monedaDeuda || ""}
        </h3>
      </div>
      <br></br>
      <div className="col-md-6 datosGeneralesBox">
        <h3>
          <b>Deuda remanente </b>
          {(causaState.montoDeuda || 0).toLocaleString() +
            " " +
            causaState.monedaDeuda || ""}
        </h3>
        <hr></hr>

        <div className="col-md-12">
          <h4>
            <b>Cliente</b>
          </h4>
          <p>{causaState.cliente}</p>
          <br></br>
        </div>

        {editableCausa === false ? (
          <div className="col-md-12">
            <h4>
              <b>Cartera</b>
            </h4>
            <p>{causaState.portfolio}</p>
            <br></br>
          </div>
        ) : (
          <div className="col-md-12">
            <h4>
              <b>Cartera</b>
            </h4>
            <AutocompleteForms
              nameElement={"portfolio"}
              formularioBuscado={causaState}
              setformulario={setCausaState}
              formularioUpdate={formularioUpdate}
              setformularioUpdate={setformularioUpdate}
              key={resetInput}
              required={true}
              personalHandleChange={handleInputChangeCausa}
              value={causaState.portfolio}
              suggestions={portfolios.map((item) => {
                return { value: item.portfolio_id, label: item.name };
              })}
            />
            <br></br>
          </div>
        )}

        <div className="col-md-12">
          <h4>
            <b>Empresa</b>
          </h4>
          <p>{causaState.empresa ? causaState.empresa : "-"}</p>
          <br></br>
        </div>
        <div className="col-md-12">
          <h4>
            <b>Nombre deudor</b>
          </h4>
          <p>{causaState.nombre_deudor}</p>
          <br></br>
        </div>

        {editableCausa === false ? (
          <div className="col-md-12">
            <h4>
              <b>Rut Deudor</b>
            </h4>
            <p>
              {causaState.rut_deudor
                ? causaState.rut_deudor + "-" + causaState.rut_deudor_id
                : "-"}
            </p>
            <br></br>
          </div>
        ) : (
          <div className="col-md-12">
            <h4>
              <b>Rut Deudor</b>
            </h4>
            <AutocompleteForms
              nameElement={"rut_deudor"}
              formularioBuscado={causaState}
              setformulario={setCausaState}
              formularioUpdate={formularioUpdate}
              setformularioUpdate={setformularioUpdate}
              key={resetInput}
              required={true}
              personalHandleChange={handleInputChangeCausa}
              value={causaState.rut_deudor}
              suggestions={deudoresState.map((item) => {
                return { value: item.value, label: item.value };
              })}
            />
            <br></br>
          </div>
        )}

        {editableCausa === false ? (
          <div className="col-md-12">
            <h4>
              <b>Estrategia</b>
            </h4>
            <p>{causaState.strategy ? causaState.strategy : "-"}</p>
            <br></br>
          </div>
        ) : (
          <div className="col-md-12">
            <h4>
              <b>Estrategia</b>
            </h4>
            <input
              onChange={(e) => {
                handleInputChangeCausa(e);
              }}
              value={causaState.strategy ? causaState.strategy : ""}
              name="strategy"
              className="form-control"
            ></input>
            <br></br>
          </div>
        )}

        {exhortos.length > 0 && (
          <div className="col-md-12">
            <h4>
              <b>ROL Exhorto</b>
            </h4>
            <p>
              {exhortos
                .map((e) => e.role_exhorted)
                .filter(Boolean)
                .join(", ") || "—"}
            </p>
            <br></br>
          </div>
        )}
      </div>
      <div className="col-md-6 datosGeneralesBox">
        <h3>
          <b>Estado</b>{" "}
          <span
            style={{
              backgroundColor: causaState?.state_colour,
              padding: "4px 8px",
              borderRadius: 4,
            }}
          >
            {causaState.state_name}
          </span>
        </h3>
        <hr></hr>

        {editableCausa === false ? (
          <div className="col-md-12">
            <h4>
              <b>Libro/Tipo</b>
            </h4>
            <p>{causaState.rol_tribunal ? causaState.rol_tribunal : "-"}</p>
            <br></br>
          </div>
        ) : (
          <div className="col-md-12">
            <h4>
              <b>Libro/Tipo</b>
            </h4>

            <AutocompleteForms
              nameElement={"rol_tribunal"}
              formularioBuscado={causaState}
              setformulario={setCausaState}
              key={resetInput}
              required={true}
              personalHandleChange={handleInputChangeCausa}
              value={causaState.rol_tribunal ? causaState.rol_tribunal : ""}
              suggestions={rolTribunal.map((item) => {
                return { value: item.court_role_id, label: item.name };
              })}
              formularioUpdate={formularioUpdate}
              setformularioUpdate={setformularioUpdate}
            />
            <br></br>
          </div>
        )}

        {editableCausa === false ? (
          <div className="col-md-12">
            <h4>
              <b>Rol</b>
            </h4>
            <p>{causaState.rol ? causaState.rol : "-"}</p>
            <br></br>
          </div>
        ) : (
          <div className="col-md-12">
            <h4>
              <b>Rol</b>
            </h4>
            <input
              onChange={(e) => {
                handleInputChangeCausa(e);
              }}
              value={causaState.rol ? causaState.rol : ""}
              name="rol"
              className="form-control"
            ></input>
            <br></br>
          </div>
        )}

        {editableCausa === false ? (
          <div className="col-md-12">
            <h4>
              <b>Tribunal</b>
            </h4>
            <p>
              {causaState.nombre_tribunal ? causaState.nombre_tribunal : "-"}
            </p>
            <br></br>
          </div>
        ) : (
          <div className="col-md-12">
            <h4>
              <b>Tribunal</b>
            </h4>

            <AutocompleteForms
              nameElement={"nombre_tribunal"}
              formularioBuscado={causaState}
              setformulario={setCausaState}
              key={resetInput}
              required={true}
              personalHandleChange={handleInputChangeCausa}
              value={
                causaState.nombre_tribunal ? causaState.nombre_tribunal : ""
              }
              suggestions={tribunales.map((item) => {
                return { value: item.court_id, label: item.name };
              })}
              formularioUpdate={formularioUpdate}
              setformularioUpdate={setformularioUpdate}
            />
            <br></br>
          </div>
        )}

        {editableCausa === false ? (
          <div className="col-md-12">
            <h4>
              <b>Tipo de causa</b>
            </h4>
            <p>{causaState.tipo_causa ? causaState.tipo_causa : "-"}</p>
            <br></br>
          </div>
        ) : (
          <div className="col-md-12">
            <h4>
              <b>Tipo de causa</b>
            </h4>
            <AutocompleteForms
              nameElement={"tipo_causa"}
              formularioBuscado={causaState}
              setformulario={setCausaState}
              key={resetInput}
              required={true}
              personalHandleChange={handleInputChangeCausa}
              value={causaState.tipo_causa ? causaState.tipo_causa : ""}
              formularioUpdate={formularioUpdate}
              setformularioUpdate={setformularioUpdate}
              suggestions={tipoProceso.map((item) => {
                return { value: item.coll_proc_type_id, label: item.name };
              })}
            />
            <br></br>
          </div>
        )}

        {editableCausa === false ? (
          <div className="col-md-12">
            <h4>
              <b>N° Operación</b>
            </h4>
            <p>{causaState.n_operation ? causaState.n_operation : "-"}</p>
            <br></br>
          </div>
        ) : (
          <div className="col-md-12">
            <h4>
              <b>N° Operación</b>
            </h4>
            <input
              onChange={(e) => {
                handleInputChangeCausa(e);
              }}
              target={"n_operation"}
              name={"n_operation"}
              value={causaState.n_operation ? causaState.n_operation : ""}
              className="form-control"
            ></input>
            <br></br>
          </div>
        )}

        <div className="col-md-12">
          <h4>
            <b>Etapa</b>
          </h4>
          <p>{causaState?.stage_name}</p>
          <br></br>
        </div>

        {exhortos.length > 0 && (
          <div className="col-md-12">
            <h4>
              <b>Tribunal Exhorto</b>
            </h4>
            <p>
              {exhortos
                .map((e) => e.court_exhorted)
                .filter(Boolean)
                .join(", ") || "—"}
            </p>
            <br></br>
          </div>
        )}
      </div>
    </div>
  );

  let updateModules = (modulo, id, item) => {
    let status;
    if (modulo === "Etapas") {
      fetch(Parametros.post + "coll_proc/stages/" + item.coll_proc_stage_id, {
        method: "PUT",
        body: JSON.stringify(formularioUpdate),
        headers: {
          Authorization: "Bearer " + usuario.key,
          Accept: "application/json",
          "Content-Type": "application/json",
          Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
        },
      })
        .then((response) => {
          status = response.status;
          if (response.status === 200 || response.status === 201) {
            return response.json();
          } else if (response.status === Parametros.loginTokenExcept) {
            alert(Parametros.loginTokenExceptMessage);
            history.push({
              pathname: "/",
            });
            return response;
          } else return response.json();
        })
        .then((data) => {
          if (status === 200) {
            alert(data?.message);
            getModules(modulo, id);
            setStateUpdate([]);
            setformularioUpdate({});
          } else if (status === 422) {
            alert(data?.detail?.[0]?.msg);
            if (update.length !== 0) {
              controlState.setListaUpdate(JSON.parse(JSON.stringify(update)));
              setStateUpdate([]);
              setformularioUpdate({});
            } else {
              // controlState.setListaUpdate(JSON.parse(JSON.stringify(update)))
              // setStateUpdate([])
              setformularioUpdate({});
            }

            setEditable({ id: "" });
          } else {
            if (update.length !== 0) {
              controlState.setListaUpdate(JSON.parse(JSON.stringify(update)));
              setStateUpdate([]);
              setformularioUpdate({});
            } else {
              // controlState.setListaUpdate(JSON.parse(JSON.stringify(update)))
              // setStateUpdate([])
              setformularioUpdate({});
            }

            setEditable({ id: "" });

            alert(data?.detail);
          }
        });
    }

    if (modulo === "Estados") {
      // paymentsState.debt_id

      fetch(
        Parametros.post +
          `coll_proc/state?coll_proc_id=${id}&state=${item.state_id}&startdate=${initialEditItem.startdate}`,
        {
          method: "PUT",
          body: JSON.stringify({
            ...formularioUpdate,
            state_id: causaState.state_id,
          }),
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        }
      )
        .then((response) => {
          status = response.status;
          if (response.status === 200 || response.status === 201) {
            return response.json();
          } else if (response.status === Parametros.loginTokenExcept) {
            alert(Parametros.loginTokenExceptMessage);
            history.push({
              pathname: "/",
            });
            return response;
          }
        })
        .then((data) => {
          if (status === 200) {
            alert(data?.message);
            getModules(modulo, id);
            setStateUpdate([]);
            setformularioUpdate({});
          } else if (status === 422) {
            alert(data?.detail?.[0]?.msg);
            if (update.length !== 0) {
              controlState.setListaUpdate(JSON.parse(JSON.stringify(update)));
              setStateUpdate([]);
              setformularioUpdate({});
            } else {
              // controlState.setListaUpdate(JSON.parse(JSON.stringify(update)))
              // setStateUpdate([])
              setformularioUpdate({});
            }
            setEditable({ id: "" });
          } else {
            if (update.length !== 0) {
              controlState.setListaUpdate(JSON.parse(JSON.stringify(update)));
              setStateUpdate([]);
              setformularioUpdate({});
            } else {
              // controlState.setListaUpdate(JSON.parse(JSON.stringify(update)))
              // setStateUpdate([])
              setformularioUpdate({});
            }

            setEditable({ id: "" });

            alert(data?.detail);
          }
          setInitialEditItem({});
        })
        .catch((err) => console.log(err));
    }

    if (modulo === "Historial") {
      let formulario = {};

      // formulario.type = parseInt(item.type)
      formulario.details = item.details;

      callActionsResultState.map((itemFilter) => {
        if (normalizarTexto(itemFilter.name) === normalizarTexto(item.result)) {
          formulario.result = itemFilter.call_action_result_id;
        }
        return itemFilter;
      });

      collActionTypeState.map((itemFilter) => {
        if (normalizarTexto(itemFilter.name) === normalizarTexto(item.type)) {
          formulario.type = itemFilter.call_action_type_id;
        } else {
          formulario.type = 1;
        }
        return itemFilter;
      });

      fetch(Parametros.post + "/coll_proc/history/" + item.coll_action_id, {
        method: "PUT",
        body: JSON.stringify(formulario),
        headers: {
          Authorization: "Bearer " + usuario.key,
          Accept: "application/json",
          "Content-Type": "application/json",
          Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
        },
      })
        .then((response) => {
          status = response.status;
          if (response.status === 200 || response.status === 201) {
            return response.json();
          } else if (response.status === Parametros.loginTokenExcept) {
            alert(Parametros.loginTokenExceptMessage);
            history.push({
              pathname: "/",
            });
            return response;
          }
        })
        .then((data) => {
          if (status === 200) {
            alert(data?.message);
            setStateUpdate([]);
            setformularioUpdate({});

            getModules(modulo, id);
          } else if (status === 422) {
            alert(data?.detail?.[0]?.msg);
            if (update.length !== 0) {
              controlState.setListaUpdate(JSON.parse(JSON.stringify(update)));
              setStateUpdate([]);
              setformularioUpdate({});
            } else {
              // controlState.setListaUpdate(JSON.parse(JSON.stringify(update)))
              // setStateUpdate([])
              setformularioUpdate({});
            }

            setEditable({ id: "" });
          } else {
            alert(data?.detail);
            if (update.length !== 0) {
              controlState.setListaUpdate(JSON.parse(JSON.stringify(update)));
              setStateUpdate([]);
              setformularioUpdate({});
            } else {
              // controlState.setListaUpdate(JSON.parse(JSON.stringify(update)))
              // setStateUpdate([])
              setformularioUpdate({});
            }

            setEditable({ id: "" });
          }
        });
    }

    if (modulo === "Pagos") {
      let formulario = formularioUpdate;

      formulario.amount = parseInt(item.amount);

      fetch(Parametros.post + "coll_proc/payment/" + item.payment_id, {
        method: "PUT",
        body: JSON.stringify(formulario),
        headers: {
          Authorization: "Bearer " + usuario.key,
          Accept: "application/json",
          "Content-Type": "application/json",
          Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
        },
      })
        .then((response) => {
          status = response.status;
          if (response.status === 200 || response.status === 201) {
            return response.json();
          } else if (response.status === Parametros.loginTokenExcept) {
            alert(Parametros.loginTokenExceptMessage);
            history.push({
              pathname: "/",
            });
            return response;
          }
        })
        .then((data) => {
          if (status === 200) {
            alert(data?.message);
            getModules(modulo, id);
            setStateUpdate([]);
            setformularioUpdate({});
            setUpdateCausa((prev) => !prev);
          } else if (status === 422) {
            alert(data?.detail?.[0]?.msg);
            if (update.length !== 0) {
              controlState.setListaUpdate(JSON.parse(JSON.stringify(update)));
              setStateUpdate([]);
              setformularioUpdate({});
            } else {
              // controlState.setListaUpdate(JSON.parse(JSON.stringify(update)))
              // setStateUpdate([])
              setformularioUpdate({});
            }

            setEditable({ id: "" });
          } else {
            alert(data?.detail);
            if (update.length !== 0) {
              controlState.setListaUpdate(JSON.parse(JSON.stringify(update)));
              setStateUpdate([]);
              setformularioUpdate({});
            } else {
              // controlState.setListaUpdate(JSON.parse(JSON.stringify(update)))
              // setStateUpdate([])
              setformularioUpdate({});
            }

            setEditable({ id: "" });
          }
        });
    }

    if (modulo === "Titulos") {
      fetch(Parametros.post + "coll_proc/debt_title/" + item.debt_title_id, {
        method: "PUT",
        body: JSON.stringify(formularioUpdate),
        headers: {
          Authorization: "Bearer " + usuario.key,
          Accept: "application/json",
          "Content-Type": "application/json",
          Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
        },
      })
        .then((response) => {
          status = response.status;
          if (response.status === 200 || response.status === 201) {
            return response.json();
          } else if (response.status === Parametros.loginTokenExcept) {
            alert(Parametros.loginTokenExceptMessage);
            history.push({
              pathname: "/",
            });
            return response;
          }
        })
        .then((data) => {
          if (status === 200) {
            getModules(modulo, id);
            alert(data?.message);

            setStateUpdate([]);
            setformularioUpdate({});
          } else if (status === 422) {
            alert(data?.detail?.[0]?.msg);
            if (update.length !== 0) {
              controlState.setListaUpdate(JSON.parse(JSON.stringify(update)));
              setStateUpdate([]);
              setformularioUpdate({});
            } else {
              // controlState.setListaUpdate(JSON.parse(JSON.stringify(update)))
              // setStateUpdate([])
              setformularioUpdate({});
            }

            setEditable({ id: "" });
          } else {
            alert(data?.detail);
            if (update.length !== 0) {
              controlState.setListaUpdate(JSON.parse(JSON.stringify(update)));
              setStateUpdate([]);
              setformularioUpdate({});
            } else {
              // controlState.setListaUpdate(JSON.parse(JSON.stringify(update)))
              // setStateUpdate([])
              setformularioUpdate({});
            }

            setEditable({ id: "" });
          }
        });
    }
    if (modulo === "Bienes") {
      let formulario = formularioUpdate;
      formulario.score = parseInt(item.score);
      formulario.value = parseInt(item.value);

      fetch(Parametros.post + "coll_proc/asset/" + item.person_asset_id, {
        method: "PUT",
        body: JSON.stringify(formulario),
        headers: {
          Authorization: "Bearer " + usuario.key,
          Accept: "application/json",
          "Content-Type": "application/json",
          Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
        },
      })
        .then((response) => {
          status = response.status;
          if (response.status === 200 || response.status === 201) {
            return response.json();
          } else if (response.status === Parametros.loginTokenExcept) {
            alert(Parametros.loginTokenExceptMessage);
            history.push({
              pathname: "/",
            });
            return response;
          }
        })
        .then((data) => {
          if (status === 200) {
            alert(data?.message);
            getModules(modulo, id);
            setStateUpdate([]);
            setformularioUpdate({});
          } else if (status === 422) {
            alert(data?.detail?.[0]?.msg);
            if (update.length !== 0) {
              controlState.setListaUpdate(JSON.parse(JSON.stringify(update)));
              setStateUpdate([]);
              setformularioUpdate({});
            } else {
              // controlState.setListaUpdate(JSON.parse(JSON.stringify(update)))
              // setStateUpdate([])
              setformularioUpdate({});
            }

            setEditable({ id: "" });
          } else {
            alert(data?.detail);
            if (update.length !== 0) {
              controlState.setListaUpdate(JSON.parse(JSON.stringify(update)));
              setStateUpdate([]);
              setformularioUpdate({});
            } else {
              // controlState.setListaUpdate(JSON.parse(JSON.stringify(update)))
              // setStateUpdate([])
              setformularioUpdate({});
            }

            setEditable({ id: "" });
          }
        });
    }
    if (modulo === "Contactos") {
      let formulario = {};

      formulario.value = item.value;

      claseContactoState.map((itemFilter) => {
        if (
          normalizarTexto(itemFilter.name) ===
          normalizarTexto(item.contactclass)
        ) {
          formulario.contactclass = itemFilter.contact_class_id;
        }
        return itemFilter;
      });

      tipoContactoState.map((itemFilter) => {
        if (
          normalizarTexto(itemFilter.name) === normalizarTexto(item.contacttype)
        ) {
          formulario.contacttype = itemFilter.contact_type_id;
        }
        return itemFilter;
      });

      origenDatosState.map((itemFilter) => {
        if (
          normalizarTexto(itemFilter.description) ===
          normalizarTexto(item.dataorigin)
        ) {
          return (formulario.dataorigin = itemFilter.origin_id);
        }
        return itemFilter;
      });

      fetch(Parametros.post + "coll_proc/contact/" + item.pa_person_id, {
        method: "PUT",
        body: JSON.stringify(formularioUpdate),
        headers: {
          Authorization: "Bearer " + usuario.key,
          Accept: "application/json",
          "Content-Type": "application/json",
          Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
        },
      })
        .then((response) => {
          status = response.status;
          if (response.status === 200 || response.status === 201) {
            return response.json();
          } else if (response.status === Parametros.loginTokenExcept) {
            alert(Parametros.loginTokenExceptMessage);
            history.push({
              pathname: "/",
            });
            return response;
          }
        })
        .then((data) => {
          if (status === 200) {
            alert(data?.message);
            getModules(modulo, id);
            setStateUpdate([]);
            setformularioUpdate({});
          } else if (status === 422) {
            alert(data?.detail?.[0]?.msg);
            if (update.length !== 0) {
              controlState.setListaUpdate(JSON.parse(JSON.stringify(update)));
              setStateUpdate([]);
              setformularioUpdate({});
            } else {
              // controlState.setListaUpdate(JSON.parse(JSON.stringify(update)))
              // setStateUpdate([])
              setformularioUpdate({});
            }

            setEditable({ id: "" });
          } else {
            alert(data?.detail);
            if (update.length !== 0) {
              controlState.setListaUpdate(JSON.parse(JSON.stringify(update)));
              setStateUpdate([]);
              setformularioUpdate({});
            } else {
              // controlState.setListaUpdate(JSON.parse(JSON.stringify(update)))
              // setStateUpdate([])
              setformularioUpdate({});
            }

            setEditable({ id: "" });
          }
        });
    }
    if (modulo === "Direcciones") {
      let newform = {};

      if (formularioUpdate.origin_data) {
        newform.dataorigin = formularioUpdate.origin_data;
      }
      if (formularioUpdate.address_id) {
        newform.address = formularioUpdate.address_id;
      }
      if (formularioUpdate.score) {
        newform.score = formularioUpdate.score;
      }
      if (formularioUpdate.address_unit) {
        newform.address_unit = formularioUpdate.address_unit;
      }
      if (formularioUpdate.address_type) {
        newform.address_type = formularioUpdate.address_type;
      }

      fetch(
        Parametros.post + "coll_proc/address/" + parseInt(item.pa_person_id),
        {
          method: "PUT",
          body: JSON.stringify(newform),
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        }
      )
        .then((response) => {
          status = response.status;

          if (response.status === 200 || response.status === 201) {
            return response.json();
          } else if (response.status === Parametros.loginTokenExcept) {
            alert(Parametros.loginTokenExceptMessage);
            history.push({
              pathname: "/",
            });
            return response.json();
          } else {
            return response.json();
          }
        })
        .then((data) => {
          if (status === 200) {
            alert(data?.message);
            getModules(modulo, id);
            setStateUpdate([]);
            setformularioUpdate({});
          } else if (status === 422) {
            alert(data?.detail?.[0]?.msg);
            if (update.length !== 0) {
              controlState.setListaUpdate(JSON.parse(JSON.stringify(update)));
              setStateUpdate([]);
              setformularioUpdate({});
            } else {
              // controlState.setListaUpdate(JSON.parse(JSON.stringify(update)))
              // setStateUpdate([])
              setformularioUpdate({});
            }

            setEditable({ id: "" });
          } else {
            alert(data?.detail);
            if (update.length !== 0) {
              controlState.setListaUpdate(JSON.parse(JSON.stringify(update)));
              setStateUpdate([]);
              setformularioUpdate({});
            } else {
              // controlState.setListaUpdate(JSON.parse(JSON.stringify(update)))
              // setStateUpdate([])
              setformularioUpdate({});
            }

            setEditable({ id: "" });
          }
        });
    }
    if (modulo === "Gastos Normales") {
      let formulario = formularioUpdate;

      //

      fetch(
        Parametros.post + "coll_proc/expense/" + parseInt(item.expense_id),
        {
          method: "PUT",
          body: JSON.stringify(formulario),
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        }
      )
        .then((response) => {
          status = response.status;
          if (response.status === 200 || response.status === 201) {
            return response.json();
          } else if (response.status === Parametros.loginTokenExcept) {
            alert(Parametros.loginTokenExceptMessage);
            history.push({
              pathname: "/",
            });
            return response.json();
          }
        })
        .then((data) => {
          if (status === 200) {
            alert(data?.message);
            getModules(modulo, id);
            setStateUpdate([]);
            setformularioUpdate({});
          } else if (status === 422) {
            alert(data?.detail?.[0]?.msg);
            if (update.length !== 0) {
              controlState.setListaUpdate(JSON.parse(JSON.stringify(update)));
              setStateUpdate([]);
              setformularioUpdate({});
            } else {
              // controlState.setListaUpdate(JSON.parse(JSON.stringify(update)))
              // setStateUpdate([])
              setformularioUpdate({});
            }

            setEditable({ id: "" });
          } else {
            alert(data?.detail);
            if (update.length !== 0) {
              controlState.setListaUpdate(JSON.parse(JSON.stringify(update)));
              setStateUpdate([]);
              setformularioUpdate({});
            } else {
              // controlState.setListaUpdate(JSON.parse(JSON.stringify(update)))
              // setStateUpdate([])
              setformularioUpdate({});
            }

            setEditable({ id: "" });
          }
        });
    }

    // const nuevoObjeto = JSON.parse(JSON.stringify(update));
    // controlState.setListaUpdate(nuevoObjeto)
    // setControlState({ setListaUpdate: setLista })
    // setStateUpdate([])
    setformularioUpdate({});
  };
  async function tabControl(evt, tabseleccion) {
    if (usuario.modulos.includes(tabseleccion)) {
      var i, tabcontent, tablinks;
      tabcontent = document.getElementsByClassName("tabcontent");
      for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
      }
      tablinks = document.getElementsByClassName("tablinks");
      for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
      }
      document.getElementById(tabseleccion).style.display = "block";
      evt.currentTarget.className += " active";

      getModules(tabseleccion, causaState.coll_proc_id);
    } else {
      alert("no tiene permisos para acceder a este elemento");
    }
  }
  let editar = (id, lista, setLista, modulo) => {
    setformularioUpdate({});
    if (usuario.permisos.indexOf("Actualizar") > -1) {
      if (update.length === 0) {
        setControlState({ setListaUpdate: setLista });
        setStateUpdate(JSON.parse(JSON.stringify(lista)));
      } else {
        controlState.setListaUpdate(JSON.parse(JSON.stringify(update)));
        setControlState({ setListaUpdate: setLista });
        setStateUpdate([]);
        setformularioUpdate({});

        //
      }
      setEditable(id + modulo);
    } else {
      alert("No tiene los permisos para realizar esta acción");
    }
  };
  let cancelarEdicion = (item, lista, setLista) => {
    if (update.length !== 0) {
      controlState.setListaUpdate(JSON.parse(JSON.stringify(update)));
      setStateUpdate([]);
      setformularioUpdate({});
    } else {
      // controlState.setListaUpdate(JSON.parse(JSON.stringify(update)))
      // setStateUpdate([])
      setformularioUpdate({});
    }

    setEditable({ id: "" });
  };
  let handleInputChange = (index, e, setState, listaState, autocomplete) => {
    if (update.length === 0) {
      controlState.setListaUpdate(JSON.parse(JSON.stringify(update)));
      setStateUpdate(JSON.parse(JSON.stringify(listaState)));
    }

    if (listaState[0].assets) {
      let newArray = JSON.parse(JSON.stringify(listaState));
      newArray[0].assets[index][e.target.name] = e.target.value;
      setState(JSON.parse(JSON.stringify(newArray)));
    } else if (listaState[0].contacts) {
      let newArray = JSON.parse(JSON.stringify(listaState));

      if (autocomplete === true) {
        newArray[0].contacts[index][e.target.getAttribute("name")] =
          e.currentTarget.innerText;
      } else {
        newArray[0].contacts[index][e.target.getAttribute("name")] =
          e.target.value;
      }

      setState(JSON.parse(JSON.stringify(newArray)));
    } else if (listaState[0].addresses) {
      let newArray = JSON.parse(JSON.stringify(listaState));

      if (autocomplete === true) {
        newArray[0].addresses[index][e.target.getAttribute("name")] =
          e.currentTarget.innerText;
      } else {
        newArray[0].addresses[index][e.target.getAttribute("name")] =
          e.target.value;
      }

      setState(JSON.parse(JSON.stringify(newArray)));
    } else if (listaState[0].debt_payments) {
      let newArray = JSON.parse(JSON.stringify(listaState));

      if (autocomplete === true) {
        newArray[0].debt_payments[index][e.target.getAttribute("name")] =
          e.currentTarget.innerText;
      } else {
        newArray[0].debt_payments[index][e.target.getAttribute("name")] =
          e.target.value;
      }

      setState(JSON.parse(JSON.stringify(newArray)));
    } else if (listaState[0].debt_titles) {
      let newArray = JSON.parse(JSON.stringify(listaState));

      if (autocomplete === true) {
        newArray[0].debt_titles[index][e.target.getAttribute("name")] =
          e.currentTarget.innerText;
      } else {
        newArray[0].debt_titles[index][e.target.getAttribute("name")] =
          e.target.value;
      }

      setState(JSON.parse(JSON.stringify(newArray)));
    } else {
      let newList = listaState;
      if (autocomplete === true) {
        newList[index][e.target.getAttribute("name")] =
          e.currentTarget.innerText;
      } else {
        newList[index][e.target.getAttribute("name")] = e.target.value;
      }
      setState(JSON.parse(JSON.stringify(newList)));
    }

    const name = e.target.getAttribute("name");
    const value = e.currentTarget.value
      ? e.currentTarget.value
      : e.currentTarget.innerText;
    let estadoUpdate = formularioUpdate;
    estadoUpdate[name] = value;

    setformularioUpdate(JSON.parse(JSON.stringify(estadoUpdate)));
  };
  let confirmarEdicion = async (e, item, lista, setLista) => {
    setEditable({});

    updateModules(editable.slice(1), causaState.coll_proc_id, item);
  };
  let etapa = (
    <>
      {/* <h5>{JSON.stringify(stagesState)}</h5> */}
      <div className="col-md-12" style={{ marginBottom: 12 }}>
        <div className="col-md-4" style={{ padding: 0 }}>
          <ReactSelect
            value={currentNotebook}
            defaultValue={currentNotebook}
            onChange={(opt) => setCurrentNotebook(opt)}
            options={notebooks?.map((note) => ({
              value: note.notebook_id,
              label: note.name,
            }))}
          />
        </div>
        <div className="col-md-4"></div>
        <div className="col-md-4 text-right">
          <button
            className="btn  btn-primary"
            onClick={(event) => controlForm("Etapas")}
          >
            Crear
          </button>
        </div>
      </div>
      <div className="col-md-12 table-responsive-causas">
        <Table
          id={1}
          type={1}
          elementos={[
            "Etapa",
            "Sub Etapa",
            "Fecha etapa",
            "Fecha creación",
            "Responsable",
            "Comentario",
            "Persona asociada",
          ]}
        ></Table>
        <table className="table table-bordered" id="1">
          <Table
            idName="Código"
            id={1}
            type={2}
            elementos={[
              "Etapa",
              "Sub Etapa",
              "Fecha etapa",
              "Fecha creación",
              "Responsable",
              "Comentario",
              "Persona asociada",
            ]}
          ></Table>
          <tbody className="ajusteTabladata">
            {stagesState.length > 0 &&
              stagesState?.map((item, index) => {
                return (
                  <tr key={index}>
                    {editable === index + "Etapas" ? (
                      <>
                        <td>{item.internal_id}</td>
                        <td>{item.stage_type_name}</td>
                        <td>
                          <AutocompleteInputModule
                            suggestions={subStages?.map((item) => {
                              return { value: item.stage_id, label: item.name };
                            })}
                            value={item.stage}
                            setformularioUpdate={setformularioUpdate}
                            formularioUpdate={formularioUpdate}
                            handleInput={handleInputChange}
                            setState={setstages}
                            i={index}
                            state={stagesState}
                            name={"stage"}
                          ></AutocompleteInputModule>
                        </td>
                        <td>
                          <input
                            value={item.startdate}
                            type={"date"}
                            name="startdate"
                            onChange={(event) => {
                              handleInputChange(
                                index,
                                event,
                                setstages,
                                stagesState
                              );
                            }}
                            className="form-control"
                          ></input>
                        </td>

                        <td>
                          <input
                            value={item.created_at}
                            type={"date"}
                            name="created_at"
                            onChange={(event) => {
                              handleInputChange(
                                index,
                                event,
                                setstages,
                                stagesState
                              );
                            }}
                            className="form-control"
                          ></input>
                        </td>
                        <td> {item.user_email}</td>
                        <td>
                          <input
                            value={item.comment}
                            name="comment"
                            onChange={(event) => {
                              handleInputChange(
                                index,
                                event,
                                setstages,
                                stagesState
                              );
                            }}
                            className="form-control"
                          ></input>
                        </td>
                        <td>
                          <AutocompleteInputModule
                            suggestions={persons.map((item) => {
                              return {
                                value: item.person_uid,
                                label: item.full_name,
                              };
                            })}
                            value={item.associated_person}
                            setformularioUpdate={setformularioUpdate}
                            formularioUpdate={formularioUpdate}
                            handleInput={handleInputChange}
                            setState={setstages}
                            i={index}
                            state={stagesState}
                            name={"associated_person"}
                          ></AutocompleteInputModule>
                        </td>
                        <td>
                          <abbr title="Confirmar Edición">
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={(e) => {
                                confirmarEdicion(
                                  e,
                                  item,
                                  stagesState,
                                  setstages
                                );
                              }}
                              className="glyphicon glyphicon glyphicon-ok"
                            >
                              {" "}
                            </span>
                          </abbr>
                          <abbr title="Cancelar Edición">
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                cancelarEdicion(item, stagesState, setstages);
                              }}
                              className="glyphicon glyphicon-share-alt"
                            ></span>
                          </abbr>
                        </td>
                      </>
                    ) : (
                      <>
                        {usuario.permisos.indexOf("Ver") > -1 ? (
                          <>
                            <td>{item.internal_id}</td>
                            <td>{item.stage_type_name}</td>
                            <td> {item.stage}</td>
                            <td> {item.startdate}</td>
                            <td> {item.created_at}</td>
                            <td> {item.user_email}</td>
                            <td> {item.comment}</td>
                            <td> {item.associated_person}</td>

                            <td>
                              <abbr title="Editar Elemento">
                                {" "}
                                <span
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    editar(
                                      index,
                                      stagesState,
                                      setstages,
                                      "Etapas"
                                    );
                                  }}
                                  className="glyphicon glyphicon-pencil"
                                >
                                  {" "}
                                </span>
                              </abbr>
                              <EliminarElemento
                                endpoint={`coll_proc/stages/is_active/${item.coll_proc_stage_id}`}
                                onSuccess={() => {
                                  setUpdateCausa((prev) => !prev);
                                }}
                              />
                            </td>
                          </>
                        ) : (
                          <>
                            <h1>no tiene permisos para ver</h1>
                          </>
                        )}
                      </>
                    )}
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </>
  );
  let estado = (
    <>
      {/* <h5>{JSON.stringify(statesState)}</h5> */}
      <div className="col-md-12">
        <div className="col-md-4"></div>
        <div className="col-md-4"></div>
        <div className="col-md-4 text-right">
          <button
            className="btn  btn-primary"
            onClick={(event) => controlForm("Estados")}
          >
            Crear
          </button>
        </div>
      </div>
      <div className="col-md-12 table-responsive-causas">
        <Table
          id={2}
          type={1}
          elementos={[
            "Estado",
            "Inicio",
            "Responsable",
            "Fecha Registro",
            "Comentario",
          ]}
        ></Table>
        <table className="table table-bordered" id="2">
          <Table
            id={2}
            type={2}
            elementos={[
              "Estado",
              "Inicio",
              "Responsable",
              "Fecha Registro",
              "Comentario",
            ]}
          ></Table>
          <tbody className="ajusteTabladata">
            {statesState.map((item, index) => {
              return (
                <tr key={index}>
                  {editable === index + "Estados" ? (
                    <>
                      <td>{index + 1}</td>
                      <td>
                        <AutocompleteInputModule
                          suggestions={estados.map((item) => {
                            return { value: item.state_id, label: item.name };
                          })}
                          value={item.state_id}
                          setformularioUpdate={setformularioUpdate}
                          formularioUpdate={formularioUpdate}
                          handleInput={handleInputChange}
                          setState={setstates}
                          i={index}
                          state={statesState}
                          name={"state_id"}
                        ></AutocompleteInputModule>
                      </td>
                      <td>
                        <input
                          value={item.startdate}
                          type={"date"}
                          name="startdate"
                          onChange={(event) => {
                            handleInputChange(
                              index,
                              event,
                              setstates,
                              statesState
                            );
                          }}
                          className="form-control"
                        ></input>
                      </td>
                      <td> {item.user_email}</td>
                      <td>{item.created_at}</td>
                      <td>
                        <input
                          value={item.comment}
                          type="text"
                          name="comment"
                          onChange={(event) => {
                            handleInputChange(
                              index,
                              event,
                              setstates,
                              statesState
                            );
                          }}
                          className="form-control"
                        ></input>
                      </td>{" "}
                      <td>
                        <abbr title="Confirmar Edición">
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={(e) => {
                              confirmarEdicion(e, item, statesState, setstates);
                            }}
                            className="glyphicon glyphicon glyphicon-ok"
                          >
                            {" "}
                          </span>
                        </abbr>
                        <abbr title="Cancelar Edición">
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              cancelarEdicion(item, statesState, setstates);
                              setInitialEditItem({});
                            }}
                            className="glyphicon glyphicon-share-alt"
                          ></span>
                        </abbr>
                      </td>
                    </>
                  ) : (
                    <>
                      {usuario.permisos.indexOf("Ver") > -1 ? (
                        <>
                          <td>{index + 1}</td>
                          <td> {item.state}</td>
                          <td> {item.startdate}</td>
                          <td> {item.user_email}</td>
                          <td>{item.created_at}</td>
                          <td>{item.comment}</td>

                          <td>
                            <abbr title="Editar Elemento">
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  editar(
                                    index,
                                    statesState,
                                    setstates,
                                    "Estados"
                                  );
                                  setInitialEditItem(
                                    JSON.parse(JSON.stringify(item))
                                  );
                                }}
                                className="glyphicon glyphicon-pencil"
                              ></span>
                            </abbr>
                            <EliminarElemento
                              endpoint={`coll_proc/state?state=${item.state_id}&collproc_id=${currentCollId}&startdate=${item.startdate}`}
                              onSuccess={() => setUpdateCausa((prev) => !prev)}
                            />
                          </td>
                        </>
                      ) : (
                        <>
                          <h1>no tiene permisos para ver</h1>
                        </>
                      )}
                    </>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
  let pagos = (
    <>
      {/* <h5>{JSON.stringify(paymentsState)}</h5> */}
      <div className="col-md-12">
        <div className="col-md-4"></div>
        <div className="col-md-4"></div>
        <div className="col-md-4 text-right">
          <button
            className="btn  btn-primary"
            onClick={(event) => controlForm("Pagos")}
          >
            Crear
          </button>
        </div>
      </div>
      <div className="col-md-12 table-responsive-causas">
        <Table
          id={3}
          type={1}
          elementos={[
            "Monto de pago",
            "Moneda",
            "Fecha de pago",
            "Descripción",
            "Comprobante",
            "Fecha creación",
          ]}
        ></Table>
        <table className="table table-bordered" id="3">
          <Table
            id={3}
            type={2}
            elementos={[
              "Monto de pago",
              "Moneda",
              "Fecha de pago",
              "Descripción",
              "Comprobante",
              "Fecha creación",
            ]}
          ></Table>
          <tbody className="ajusteTabladata">
            {paymentsState.map((item, i) => (
              <tr key={item.payment_id ?? `payment-${i}`}>
                {editable === i + "Pagos" ? (
                  <>
                    <td>{item.payment_id}</td>
                    <td>
                      <input
                        value={item.amount}
                        type="number"
                        name="amount"
                        onChange={(event) => {
                          handleInputChange(
                            i,
                            event,
                            setpayments,
                            paymentsState
                          );
                        }}
                        className="form-control"
                      ></input>
                    </td>
                    <td>
                      <ReactSelect
                        onChange={(opt) => {
                          setformularioUpdate((prev) => ({
                            ...prev,
                            currency: opt.value,
                          }));
                        }}
                        options={monedas?.map((item) => ({
                          value: item.currency_id,
                          label: item.isocode,
                        }))}
                      />
                    </td>

                    <td>
                      <input
                        value={item.date}
                        type={"date"}
                        name="date"
                        onChange={(event) => {
                          handleInputChange(
                            i,
                            event,
                            setpayments,
                            paymentsState
                          );
                        }}
                        className="form-control"
                      ></input>
                    </td>

                    <td> {item.description}</td>
                    <td>
                      {" "}
                      <input
                        value={item.client_payment_id}
                        type={"text"}
                        name="client_payment_id"
                        onChange={(event) => {
                          handleInputChange(
                            i,
                            event,
                            setpayments,
                            paymentsState
                          );
                        }}
                        className="form-control"
                      ></input>
                    </td>
                    <td> {item.created_at}</td>

                    <td>
                      <abbr title="Confirmar Edición">
                        <span
                          style={{ cursor: "pointer" }}
                          onClick={(e) => {
                            confirmarEdicion(
                              e,
                              item,
                              paymentsState,
                              setpayments
                            );
                          }}
                          className="glyphicon glyphicon glyphicon-ok"
                        >
                          {" "}
                        </span>
                      </abbr>
                      <abbr title="Cancelar Edición">
                        <span
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            cancelarEdicion(item, paymentsState, setpayments);
                          }}
                          className="glyphicon glyphicon-share-alt"
                        ></span>
                      </abbr>
                    </td>
                  </>
                ) : (
                  <>
                    {usuario.permisos.indexOf("Ver") > -1 ? (
                      <>
                        <td>{item.payment_id}</td>
                        <td>{item.amount}</td>
                        <td>{item.currency}</td>
                        <td> {item.date}</td>
                        <td> {item.description}</td>
                        <td> {item.client_payment_id}</td>
                        <td> {item.created_at}</td>

                        <td>
                          <abbr title="Editar Elemento">
                            {" "}
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                editar(i, paymentsState, setpayments, "Pagos");
                              }}
                              className="glyphicon glyphicon-pencil"
                            ></span>
                          </abbr>
                          <EliminarElemento
                            endpoint={`coll_proc/payment/${item.payment_id}`}
                            onSuccess={() => {
                              setUpdateCausa((prev) => !prev);
                            }}
                          />
                        </td>
                      </>
                    ) : (
                      <>
                        <h1>no tiene permisos para ver</h1>
                      </>
                    )}
                  </>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
  let gastos = (
    <>
      {/* <h5>{JSON.stringify(expensesState)}</h5> */}
      <div className="col-md-12">
        <div className="col-md-4"></div>
        <div className="col-md-4"></div>
        <div className="col-md-4 text-right">
          <button
            className="btn  btn-primary"
            onClick={(event) => controlForm("Gastos Normales")}
          >
            Crear
          </button>
        </div>
      </div>
      <div className="col-md-12 table-responsive-causas" key={updated}>
        <Table
          id={4}
          type={1}
          elementos={[
            "Tipo de Gasto",
            "Descripción",
            "Fecha",
            "Monto",
            "Moneda",
            "Persona Asociada",
            "Factura",
            "BH Receptor",
            "Estado Factura",
            "Última Modificación",
            "Modificado Por",
          ]}
        ></Table>
        <table className="table table-bordered" id="4">
          <Table
            id={4}
            type={2}
            elementos={[
              "Tipo de Gasto",
              "Descripción",
              "Fecha",
              "Monto",
              "Moneda",
              "Persona Asociada",
              "Factura",
              "BH Receptor",
              "Estado Factura",
              "Última Modificación",
              "Modificado Por",
            ]}
          ></Table>
          <tbody className="ajusteTabladata">
            {expensesState.map((item, index) => {
              return (
                <tr key={index}>
                  {editable === index + "Gastos Normales" ? (
                    <>
                      <td>{item.expense_id}</td>
                      <td>
                        <AutocompleteInputModule
                          suggestions={expensConceptState.map((item) => {
                            return {
                              value: item.concept_id,
                              label: item.name,
                            };
                          })}
                          value={item.expense_concept}
                          name={"expense_concept"}
                          handleInput={handleInputChange}
                          setState={setexpenses}
                          i={index}
                          state={expensesState}
                          setformularioUpdate={setformularioUpdate}
                          formularioUpdate={formularioUpdate}
                        ></AutocompleteInputModule>
                      </td>
                      <td>
                        <input
                          value={item.description}
                          name="description"
                          onChange={(event) => {
                            handleInputChange(
                              index,
                              event,
                              setexpenses,
                              expensesState
                            );
                          }}
                          className="form-control"
                        ></input>
                      </td>

                      <td>
                        <input
                          value={item.date}
                          type={"date"}
                          name="date"
                          onChange={(event) => {
                            handleInputChange(
                              index,
                              event,
                              setexpenses,
                              expensesState
                            );
                          }}
                          className="form-control"
                        ></input>
                      </td>
                      <td>
                        <input
                          value={item.amount}
                          type="number"
                          name="amount"
                          onChange={(event) => {
                            handleInputChange(
                              index,
                              event,
                              setexpenses,
                              expensesState
                            );
                          }}
                          className="form-control"
                        ></input>
                      </td>

                      <td>
                        <AutocompleteInputModule
                          suggestions={monedas.map((item) => {
                            return {
                              value: item.currency_id,
                              label: item.isocode,
                            };
                          })}
                          value={item.currency}
                          handleInput={handleInputChange}
                          setState={setexpenses}
                          i={index}
                          state={expensesState}
                          name={"currency"}
                          setformularioUpdate={setformularioUpdate}
                          formularioUpdate={formularioUpdate}
                        ></AutocompleteInputModule>
                      </td>
                      <td>
                        {" "}
                        <AutocompleteInputModule
                          suggestions={persons.map((item) => {
                            return {
                              value: item.person_uid,
                              label: item.full_name,
                            };
                          })}
                          value={item.associated_person}
                          setformularioUpdate={setformularioUpdate}
                          formularioUpdate={formularioUpdate}
                          handleInput={handleInputChange}
                          setState={setexpenses}
                          i={index}
                          state={expensesState}
                          name={"associated_person"}
                        ></AutocompleteInputModule>
                      </td>
                      <td>
                        <input
                          value={item.factura || ""}
                          name="factura"
                          onChange={(event) => {
                            handleInputChange(
                              index,
                              event,
                              setexpenses,
                              expensesState
                            );
                          }}
                          className="form-control"
                        ></input>
                      </td>
                      <td>
                        <input
                          value={item.bh_receptor || ""}
                          type="number"
                          name="bh_receptor"
                          onChange={(event) => {
                            handleInputChange(
                              index,
                              event,
                              setexpenses,
                              expensesState
                            );
                          }}
                          className="form-control"
                        ></input>
                      </td>
                      <td>
                        <select
                          value={item.factura_status_id || ""}
                          name="factura_status_id"
                          onChange={(event) => {
                            const v = event.target.value;
                            const parsed =
                              v === "" ? null : parseInt(v, 10);
                            const newList = JSON.parse(
                              JSON.stringify(expensesState)
                            );
                            newList[index].factura_status_id = parsed;
                            setexpenses(newList);
                            setformularioUpdate({
                              ...formularioUpdate,
                              factura_status_id: parsed,
                            });
                          }}
                          className="form-control"
                        >
                          {facturaStatusTypes.map((st) => (
                            <option
                              key={st.factura_status_id}
                              value={st.factura_status_id}
                            >
                              {st.name}
                            </option>
                          ))}
                        </select>
                      </td>
                      <td>
                        {item.ultima_modificacion
                          ? new Date(item.ultima_modificacion).toLocaleString()
                          : "—"}
                      </td>
                      <td>{item.modificado_por || "—"}</td>
                      <td>
                        <abbr title="Confirmar Edición">
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={(e) => {
                              confirmarEdicion(
                                e,
                                item,
                                expensesState,
                                setexpenses
                              );
                            }}
                            className="glyphicon glyphicon glyphicon-ok"
                          >
                            {" "}
                          </span>
                        </abbr>
                        <abbr title="Cancelar Edición">
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              cancelarEdicion(item, expensesState, setexpenses);
                            }}
                            className="glyphicon glyphicon-share-alt"
                          ></span>
                        </abbr>
                      </td>
                    </>
                  ) : (
                    <>
                      {usuario.permisos.indexOf("Ver") > -1 ? (
                        <>
                          <td>{item.expense_id}</td>
                          <td> {item.expense_concept}</td>
                          <td> {item.description}</td>
                          <td> {item.date}</td>

                          <td> {item.amount}</td>

                          <td>{item.currency}</td>
                          <td>{item.associated_person}</td>
                          <td>{item.factura || "—"}</td>
                          <td>{item.bh_receptor || "—"}</td>
                          <td>{item.estado_factura || "—"}</td>
                          <td>
                            {item.ultima_modificacion
                              ? new Date(
                                  item.ultima_modificacion
                                ).toLocaleString()
                              : "—"}
                          </td>
                          <td>{item.modificado_por || "—"}</td>

                          <td>
                            <abbr title="Editar Elemento">
                              {" "}
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  editar(
                                    index,
                                    expensesState,
                                    setexpenses,
                                    "Gastos Normales"
                                  );
                                }}
                                className="glyphicon glyphicon-pencil"
                              >
                                {" "}
                              </span>
                            </abbr>
                            <EliminarElemento
                              endpoint={`coll_proc/expense/${item.expense_id}`}
                              onSuccess={handleGetModuleGastos}
                            />
                          </td>
                        </>
                      ) : (
                        <>
                          <h1>no tiene permisos para ver</h1>
                        </>
                      )}
                    </>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
  let titulos = (
    <>
      {/* <h5>{JSON.stringify(debt_titlesState)}</h5> */}
      <div className="col-md-12">
        <div className="col-md-4"></div>
        <div className="col-md-4"></div>
        <div className="col-md-4 text-right">
          <button
            className="btn  btn-primary"
            onClick={(event) => controlForm("Títulos")}
          >
            Crear
          </button>
        </div>
      </div>
      <div className="col-md-12 table-responsive-causas">
        <Table
          id={5}
          type={1}
          elementos={[
            "Tipo",
            "Deudor",
            "Monto",
            "Moneda",
            "Fecha del título",
            "Fecha Vencimiento",
            "Comentario",
            "Comprobante",
          ]}
        ></Table>
        <table className="table table-bordered" id="5id={6} ">
          <Table
            id={5}
            type={2}
            elementos={[
              "Tipo",
              "Deudor",
              "Monto",
              "Moneda",
              "Fecha del título",
              "Fecha Vencimiento",
              "Comentario",
              "Comprobante",
            ]}
          ></Table>
          <tbody className="ajusteTabladata">
            {debt_titlesState.map((item, i) => {
              return item.debt_titles.map((itemTitle, index) => {
                return (
                  <tr key={index}>
                    {editable === index + "Titulos" ? (
                      <>
                        <td>{itemTitle.debt_title_id}</td>

                        <td>
                          <AutocompleteInputModule
                            suggestions={titulosState.map((item) => {
                              return {
                                value: item.title_type_id,
                                label: item.name,
                              };
                            })}
                            value={itemTitle.type}
                            handleInput={handleInputChange}
                            setState={setdebt_titles}
                            i={index}
                            state={debt_titlesState}
                            formularioUpdate={formularioUpdate}
                            atribute={"debt_titles"}
                            setformularioUpdate={setformularioUpdate}
                            name={"type"}
                          ></AutocompleteInputModule>
                        </td>
                        <td>{item.full_name}</td>
                        <td>
                          <input
                            value={itemTitle.amount}
                            name="amount"
                            type={"number"}
                            onChange={(event) => {
                              handleInputChange(
                                index,
                                event,
                                setdebt_titles,
                                debt_titlesState
                              );
                            }}
                            className="form-control"
                          ></input>
                        </td>
                        <td>
                          <AutocompleteInputModule
                            suggestions={monedas.map((item) => {
                              return {
                                value: item.currency_id,
                                label: item.isocode,
                              };
                            })}
                            value={itemTitle.currency}
                            handleInput={handleInputChange}
                            setState={setdebt_titles}
                            i={index}
                            state={debt_titlesState}
                            name={"currency"}
                            formularioUpdate={formularioUpdate}
                            atribute={"debt_titles"}
                            setformularioUpdate={setformularioUpdate}
                          ></AutocompleteInputModule>
                        </td>

                        <td>
                          <input
                            value={itemTitle.origindate}
                            name="origindate"
                            type={"date"}
                            onChange={(event) => {
                              handleInputChange(
                                index,
                                event,
                                setdebt_titles,
                                debt_titlesState
                              );
                            }}
                            className="form-control"
                          ></input>
                        </td>
                        <td>
                          <input
                            value={itemTitle.duedate}
                            name="duedate"
                            type={"date"}
                            onChange={(event) => {
                              handleInputChange(
                                index,
                                event,
                                setdebt_titles,
                                debt_titlesState
                              );
                            }}
                            className="form-control"
                          ></input>
                        </td>
                        <td>
                          <input
                            value={itemTitle.comment}
                            name="comment"
                            onChange={(event) => {
                              handleInputChange(
                                index,
                                event,
                                setdebt_titles,
                                debt_titlesState
                              );
                            }}
                            className="form-control"
                          ></input>
                        </td>
                        <td>
                          <input
                            value={itemTitle.client_payment_id}
                            name="client_payment_id"
                            onChange={(event) => {
                              handleInputChange(
                                index,
                                event,
                                setdebt_titles,
                                debt_titlesState
                              );
                            }}
                            className="form-control"
                          ></input>
                        </td>

                        <td>
                          <abbr title="Confirmar Edición">
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={(e) => {
                                confirmarEdicion(
                                  e,
                                  itemTitle,
                                  debt_titlesState,
                                  setdebt_titles
                                );
                              }}
                              className="glyphicon glyphicon glyphicon-ok"
                            >
                              {" "}
                            </span>
                          </abbr>
                          <abbr title="Cancelar Edición">
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                cancelarEdicion(
                                  itemTitle,
                                  debt_titlesState,
                                  setdebt_titles
                                );
                              }}
                              className="glyphicon glyphicon-share-alt"
                            ></span>
                          </abbr>
                        </td>
                      </>
                    ) : (
                      <>
                        {usuario.permisos.indexOf("Ver") > -1 ? (
                          <>
                            <td>{itemTitle.debt_title_id}</td>

                            <td>{itemTitle.debt_title_type}</td>
                            <td>{item.full_name}</td>
                            <td>{itemTitle.amount}</td>
                            <td>{itemTitle.currency}</td>
                            <td>{itemTitle.origindate}</td>
                            <td>{itemTitle.duedate}</td>
                            <td>{itemTitle.comment}</td>
                            <td>{itemTitle.client_payment_id}</td>

                            <td>
                              <abbr title="Editar Elemento">
                                {" "}
                                <span
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    editar(
                                      index,
                                      debt_titlesState,
                                      setdebt_titles,
                                      "Titulos"
                                    );
                                  }}
                                  className="glyphicon glyphicon-pencil"
                                >
                                  {" "}
                                </span>
                              </abbr>
                              <EliminarElemento
                                endpoint={`coll_proc/debt_title/${itemTitle.debt_title_id}`}
                                onSuccess={handleGetModuleTitulos}
                              />
                            </td>
                          </>
                        ) : (
                          <>
                            <h1>no tiene permisos para ver</h1>
                          </>
                        )}
                      </>
                    )}
                  </tr>
                );
              });
            })}
          </tbody>
        </table>
      </div>
    </>
  );
  let bienes = (
    <>
      <div className="col-md-12">
        <div className="col-md-4"></div>
        <div className="col-md-4"></div>
        <div className="col-md-4 text-right">
          <button
            className="btn  btn-primary"
            onClick={(event) => controlForm("Bienes")}
          >
            Crear
          </button>
        </div>
      </div>
      <div className="col-md-12 table-responsive-causas">
        <Table
          id={6}
          type={1}
          elementos={[
            "Propietario",
            "Tipo",
            "Descripción",
            "Puntaje",
            "Valor",
            "Moneda",
            "Origen de dato",
            "Fecha de dato",
            "Ciudad",
            "Comuna",
          ]}
        ></Table>
        <table className="table table-bordered" id="6">
          <Table
            id={6}
            type={2}
            elementos={[
              "Propietario",
              "Tipo",
              "Descripción",
              "Puntaje",
              "Valor",
              "Moneda",
              "Origen de dato",
              "Fecha de dato",
              "Ciudad",
              "Comuna",
            ]}
          ></Table>
          <tbody className="ajusteTabladata">
            {bienesState.map((item, index) => {
              return item.assets.map((itemBien, index) => {
                return (
                  <tr key={index}>
                    {editable === index + "Bienes" ? (
                      <>
                        <td>{itemBien.person_asset_id}</td>
                        <td>{item.full_name}</td>
                        {/* <td>{itemBien.type}</td> */}
                        <td>
                          {" "}
                          <ReactSelect
                            onChange={(opt) => {
                              setformularioUpdate((prev) => ({
                                ...prev,
                                typeAsset: opt.value,
                              }));
                            }}
                            options={tipoActivosState?.map((item) => ({
                              value: item.asset_type_id,
                              label: item.name,
                            }))}
                          />
                        </td>
                        <td>
                          <textarea
                            value={itemBien.description}
                            name="description"
                            rows={5}
                            onChange={(event) => {
                              handleInputChange(
                                index,
                                event,
                                setBienes,
                                bienesState
                              );
                            }}
                            className="form-control"
                          ></textarea>
                        </td>
                        <td>
                          <input
                            value={itemBien.score}
                            name="score"
                            type={"number"}
                            onChange={(event) => {
                              handleInputChange(
                                index,
                                event,
                                setBienes,
                                bienesState
                              );
                            }}
                            className="form-control"
                          ></input>
                        </td>
                        <td>
                          <input
                            value={itemBien.value}
                            name="value"
                            type={"number"}
                            onChange={(event) => {
                              handleInputChange(
                                index,
                                event,
                                setBienes,
                                bienesState
                              );
                            }}
                            className="form-control"
                          ></input>
                        </td>
                        <td>
                          <ReactSelect
                            onChange={(opt) => {
                              setformularioUpdate((prev) => ({
                                ...prev,
                                currency_id: opt.value,
                              }));
                            }}
                            options={monedas?.map((item) => ({
                              value: item.currency_id,
                              label: item.isocode,
                            }))}
                          />
                        </td>
                        <td>
                          <ReactSelect
                            onChange={(opt) => {
                              setformularioUpdate((prev) => ({
                                ...prev,
                                dataorigin: opt.value,
                              }));
                            }}
                            options={origenDatosState?.map((item) => ({
                              value: item.origin_id,
                              label: item.description,
                            }))}
                          />
                        </td>
                        <td>
                          <input
                            value={itemBien.infodate}
                            name="infodate"
                            type={"date"}
                            onChange={(event) => {
                              handleInputChange(
                                index,
                                event,
                                setBienes,
                                bienesState
                              );
                            }}
                            className="form-control"
                          ></input>
                        </td>
                        <td>
                          {geoAdminState.map((itemGeo) => {
                            if (
                              itemGeo.geoadmin_zone_id === itemBien.geoadmin
                            ) {
                              return itemGeo.geoadmin4;
                            } else {
                              return "";
                            }
                          })}{" "}
                        </td>
                        <td>
                          {geoAdminState.map((itemGeo) => {
                            if (
                              itemGeo.geoadmin_zone_id === itemBien.geoadmin
                            ) {
                              return itemGeo.geoadmin3;
                            } else {
                              return "";
                            }
                          })}{" "}
                        </td>
                        <td>
                          <abbr title="Confirmar Edición">
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={(e) => {
                                confirmarEdicion(
                                  e,
                                  itemBien,
                                  bienesState,
                                  setBienes
                                );
                              }}
                              className="glyphicon glyphicon glyphicon-ok"
                            >
                              {" "}
                            </span>
                          </abbr>
                          <abbr title="Cancelar Edición">
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                cancelarEdicion(item, bienesState, setBienes);
                              }}
                              className="glyphicon glyphicon-share-alt"
                            ></span>
                          </abbr>
                        </td>
                      </>
                    ) : (
                      <>
                        {usuario.permisos.indexOf("Ver") > -1 ? (
                          <>
                            <td>{itemBien.person_asset_id}</td>
                            <td>{item.full_name}</td>
                            <td>{itemBien.asset_type}</td>
                            <td>{itemBien.description}</td>
                            <td>{itemBien.score}</td>
                            <td>{itemBien.value}</td>
                            <td>{itemBien.currency}</td>
                            <td>{itemBien.origin_description}</td>
                            <td>{itemBien.infodate}</td>
                            <td>
                              {geoAdminState.map((itemGeo) => {
                                if (
                                  itemGeo.geoadmin_zone_id === itemBien.geoadmin
                                ) {
                                  return itemGeo.geoadmin4;
                                } else {
                                  return "";
                                }
                              })}{" "}
                            </td>
                            <td>
                              {geoAdminState.map((itemGeo) => {
                                if (
                                  itemGeo.geoadmin_zone_id === itemBien.geoadmin
                                ) {
                                  return itemGeo.geoadmin3;
                                } else {
                                  return "";
                                }
                              })}{" "}
                            </td>

                            <td>
                              <abbr title="Editar Elemento">
                                {" "}
                                <span
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    editar(
                                      index,
                                      bienesState,
                                      setBienes,
                                      "Bienes"
                                    );
                                  }}
                                  className="glyphicon glyphicon-pencil"
                                >
                                  {" "}
                                </span>
                              </abbr>
                              <EliminarElemento
                                endpoint={`coll_proc/asset/${itemBien.person_asset_id}`}
                                onSuccess={handleGetModuleBienes}
                              />
                            </td>
                          </>
                        ) : (
                          <>
                            <h1>no tiene permisos para ver</h1>
                          </>
                        )}
                      </>
                    )}
                  </tr>
                );
              });
            })}
          </tbody>
        </table>
      </div>
    </>
  );
  let contacto = (
    <>
      <div className="col-md-12">
        <div className="col-md-4"></div>
        <div className="col-md-4"></div>
        <div className="col-md-4 text-right">
          <button
            className="btn  btn-primary"
            onClick={(event) => controlForm("Contactos")}
          >
            Crear
          </button>
        </div>
      </div>
      <div className="col-md-12 table-responsive-causas">
        <Table
          id={7}
          type={1}
          elementos={[
            "Valor",
            "Clase de contacto",
            "Tipo de contacto",
            "Origen de datos",
            "Contacto",
          ]}
        ></Table>
        <table className="table table-bordered" id="7id={8}">
          <Table
            id={7}
            type={2}
            elementos={[
              "Valor",
              "Clase de contacto",
              "Tipo de contacto",
              "Origen de datos",
              "Contacto",
            ]}
          ></Table>
          <tbody className="ajusteTabladata">
            {contactsState.map((item, i) => {
              return item.contacts.map((itemContact, index) => {
                return (
                  <tr key={index}>
                    {editable === index + "Contactos" ? (
                      <>
                        <td>{itemContact.contact_id}</td>
                        <td>
                          <input
                            value={itemContact.value}
                            type="number"
                            name="value"
                            onChange={(event) => {
                              handleInputChange(
                                index,
                                event,
                                setcontacts,
                                contactsState
                              );
                            }}
                            className="form-control"
                          ></input>
                        </td>
                        <td>
                          <AutocompleteInputModule
                            suggestions={claseContactoState.map((item) => {
                              return {
                                value: item.contact_class_id,
                                label: item.name,
                              };
                            })}
                            value={itemContact.contactclass}
                            name={"contactclass"}
                            handleInput={handleInputChange}
                            setState={setcontacts}
                            i={index}
                            state={contactsState}
                            formularioUpdate={formularioUpdate}
                            atribute={"contacts"}
                            setformularioUpdate={setformularioUpdate}
                          ></AutocompleteInputModule>
                        </td>

                        <td>
                          <AutocompleteInputModule
                            suggestions={tipoContactoState.map((item) => {
                              return {
                                value: item.contact_type_id,
                                label: item.name,
                              };
                            })}
                            value={itemContact.contacttype}
                            name={"contacttype"}
                            handleInput={handleInputChange}
                            setState={setcontacts}
                            i={index}
                            state={contactsState}
                            formularioUpdate={formularioUpdate}
                            atribute={"contacts"}
                            setformularioUpdate={setformularioUpdate}
                          ></AutocompleteInputModule>
                        </td>
                        <td>
                          <AutocompleteInputModule
                            suggestions={origenDatosState.map((item) => {
                              return {
                                value: item.origin_id,
                                label: item.description,
                              };
                            })}
                            value={itemContact.dataorigin}
                            name={"dataorigin"}
                            handleInput={handleInputChange}
                            setState={setcontacts}
                            i={index}
                            state={contactsState}
                            formularioUpdate={formularioUpdate}
                            atribute={"contacts"}
                            setformularioUpdate={setformularioUpdate}
                          ></AutocompleteInputModule>
                        </td>
                        <td> {itemContact.additional_info}</td>
                        <td>
                          <abbr title="Confirmar Edición">
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={(e) => {
                                confirmarEdicion(
                                  e,
                                  itemContact,
                                  contactsState,
                                  setcontacts
                                );
                              }}
                              className="glyphicon glyphicon glyphicon-ok"
                            >
                              {" "}
                            </span>
                          </abbr>
                          <abbr title="Cancelar Edición">
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                cancelarEdicion(
                                  item,
                                  contactsState,
                                  setcontacts
                                );
                              }}
                              className="glyphicon glyphicon-share-alt"
                            ></span>
                          </abbr>
                        </td>
                      </>
                    ) : (
                      <>
                        {usuario.permisos.indexOf("Ver") > -1 ? (
                          <>
                            <td>{itemContact.contact_id}</td>
                            <td>{itemContact.value}</td>
                            <td>{itemContact.contactclass}</td>
                            <td>{itemContact.contacttype}</td>
                            <td>{itemContact.dataorigin}</td>
                            <td> {itemContact.additional_info}</td>

                            <td>
                              <abbr title="Editar Elemento">
                                {" "}
                                <span
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    editar(
                                      index,
                                      contactsState,
                                      setcontacts,
                                      "Contactos"
                                    );
                                  }}
                                  className="glyphicon glyphicon-pencil"
                                >
                                  {" "}
                                </span>
                              </abbr>
                              <EliminarElemento
                                endpoint={`coll_proc/contact/${itemContact.contact_id}`}
                                onSuccess={handleGetModuleContactos}
                              />
                            </td>
                          </>
                        ) : (
                          <>
                            <h1>no tiene permisos para ver</h1>
                          </>
                        )}
                      </>
                    )}
                  </tr>
                );
              });
            })}
          </tbody>
        </table>
      </div>
    </>
  );
  let direcciones = (
    <>
      <div className="col-md-12">
        <div className="col-md-4"></div>
        <div className="col-md-4"></div>
        <div className="col-md-4 text-right">
          <button
            className="btn  btn-primary"
            onClick={(event) => controlForm("Direcciones")}
          >
            Crear
          </button>
        </div>
      </div>
      <div className="col-md-12 table-responsive-causas">
        <Table
          id={8}
          type={1}
          elementos={[
            "Tipo",
            "Origen",
            "Unidad",
            "Puntaje",
            "Calle y Número",
            "País",
            "Zona",
            "Región",
            "Provincia",
            "Ciudad",
            "Comuna",
          ]}
        ></Table>
        <table className="table table-bordered" id="8">
          <Table
            id={8}
            type={2}
            elementos={[
              "Tipo",
              "Origen",
              "Unidad",
              "Puntaje",
              "Calle y Número",
              "País",
              "Zona",
              "Región",
              "Provincia",
              "Ciudad",
              "Comuna",
            ]}
          ></Table>
          <tbody className="ajusteTabladata">
            {addressState.map((item, i) => {
              return item.addresses.map((itemAddress, index) => {
                return (
                  <tr key={index}>
                    {editable === index + "Direcciones" ? (
                      <>
                        <td>{itemAddress.address_id}</td>
                        <td>
                          <AutocompleteInputModule
                            atribute={"addresses"}
                            suggestions={tipoDireccion.map((item) => {
                              return {
                                value: item.address_type_id,
                                label: item.name,
                              };
                            })}
                            value={itemAddress.address_type}
                            name={"address_type"}
                            handleInput={handleInputChange}
                            setState={setaddress}
                            i={index}
                            state={addressState}
                            setformularioUpdate={setformularioUpdate}
                            formularioUpdate={formularioUpdate}
                          ></AutocompleteInputModule>
                        </td>
                        <td>
                          <AutocompleteInputModule
                            atribute={"addresses"}
                            suggestions={origenDatosState.map((item) => {
                              return {
                                value: item.origin_id,
                                label: item.description,
                              };
                            })}
                            value={itemAddress.origin_data}
                            name={"origin_data"}
                            handleInput={handleInputChange}
                            setState={setaddress}
                            i={index}
                            state={addressState}
                            setformularioUpdate={setformularioUpdate}
                            formularioUpdate={formularioUpdate}
                          ></AutocompleteInputModule>
                        </td>

                        <td>
                          <AutocompleteInputModule
                            atribute={"addresses"}
                            suggestions={direccion_unit.map((item) => {
                              return {
                                value: item.address_unit_id,
                                label: item.name,
                              };
                            })}
                            value={itemAddress.address_unit}
                            name={"address_unit"}
                            handleInput={handleInputChange}
                            setState={setaddress}
                            i={index}
                            state={addressState}
                            setformularioUpdate={setformularioUpdate}
                            formularioUpdate={formularioUpdate}
                          ></AutocompleteInputModule>
                        </td>
                        <td>
                          <input
                            value={itemAddress.score}
                            name="score"
                            type={"number"}
                            onChange={(event) => {
                              handleInputChange(
                                index,
                                event,
                                setaddress,
                                addressState
                              );
                            }}
                            className="form-control"
                          ></input>
                        </td>

                        <td colSpan={"7"}>
                          <AutocompleteInputModule
                            atribute={"addresses"}
                            suggestions={direccionState.map((item) => {
                              return {
                                value: item.address_id,
                                label:
                                  item.street +
                                  " | " +
                                  item.unit_number +
                                  " | " +
                                  getGeoadminValue(item.geoadmin),
                              };
                            })}
                            value={itemAddress.address_id}
                            name={"address_id"}
                            handleInput={handleInputChange}
                            setState={setaddress}
                            i={index}
                            state={addressState}
                            formularioUpdate={formularioUpdate}
                            setformularioUpdate={setformularioUpdate}
                          ></AutocompleteInputModule>
                        </td>

                        {/* <td>{itemAddress.street + " " + itemAddress.number}</td> */}

                        {/* 
                                                    <td>{itemAddress.address_unit}</td>
                                                    <td>{itemAddress.country}</td>
                                                    <td>{itemAddress.geoadmin1}</td>
                                                    <td>{itemAddress.geoadmin2}</td>
                                                    <td>{itemAddress.geoadmin3}</td> */}
                        {/* <td>{geoAdminState.map((itemGeo) => {
                                                        if (itemGeo.geoadmin_zone_id === itemAddress.geoadmin) {
                                                            return itemGeo.geoadmin4
                                                        } else {
                                                            return ""
                                                        }
                                                    })}	</td>
                                                    <td>{geoAdminState.map((itemGeo) => {
                                                        if (itemGeo.geoadmin_zone_id === itemAddress.geoadmin) {
                                                            return itemGeo.geoadmin3
                                                        } else {
                                                            return ""
                                                        }
                                                    })}	</td> */}

                        <td>
                          <abbr title="Confirmar Edición">
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={(e) => {
                                confirmarEdicion(
                                  e,
                                  itemAddress,
                                  addressState,
                                  setaddress
                                );
                              }}
                              className="glyphicon glyphicon glyphicon-ok"
                            >
                              {" "}
                            </span>
                          </abbr>
                          <abbr title="Cancelar Edición">
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                cancelarEdicion(
                                  itemAddress,
                                  addressState,
                                  setaddress
                                );
                              }}
                              className="glyphicon glyphicon-share-alt"
                            ></span>
                          </abbr>
                        </td>
                      </>
                    ) : (
                      <>
                        {usuario.permisos.indexOf("Ver") > -1 ? (
                          <>
                            <td>{itemAddress.address_id}</td>
                            <td>{itemAddress.address_type}</td>
                            <td>{itemAddress.origin_data}</td>
                            <td>{itemAddress.address_unit}</td>
                            <td>{itemAddress.score}</td>
                            <td>
                              {itemAddress.street + " " + itemAddress.number}
                            </td>
                            <td>{itemAddress.country}</td>
                            <td>{itemAddress.geoadmin1}</td>
                            <td>{itemAddress.geoadmin2}</td>
                            <td>{itemAddress.geoadmin3}</td>
                            <td>
                              {geoAdminState.map((itemGeo) => {
                                if (
                                  itemGeo.geoadmin_zone_id ===
                                  itemAddress.geoadmin
                                ) {
                                  return itemGeo.geoadmin4;
                                } else {
                                  return "";
                                }
                              })}{" "}
                            </td>
                            <td>
                              {geoAdminState.map((itemGeo) => {
                                if (
                                  itemGeo.geoadmin_zone_id ===
                                  itemAddress.geoadmin
                                ) {
                                  return itemGeo.geoadmin3;
                                } else {
                                  return "";
                                }
                              })}{" "}
                            </td>

                            <td>
                              <abbr title="Editar Elemento">
                                {" "}
                                <span
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    editar(
                                      index,
                                      addressState,
                                      setaddress,
                                      "Direcciones"
                                    );
                                  }}
                                  className="glyphicon glyphicon-pencil"
                                >
                                  {" "}
                                </span>
                              </abbr>

                              <EliminarElemento
                                endpoint={`coll_proc/address/${itemAddress.pa_person_id}`}
                                onSuccess={handleGetModuleDirecciones}
                              />

                              <abbr
                                className="verMasHover"
                                style={{ position: "relative" }}
                              >
                                <div
                                  className="textHover"
                                  style={{ visibility: "hidden" }}
                                >
                                  <div>
                                    Código postal:{itemAddress.zip_code}
                                    <br></br>
                                    Coordenadas:{itemAddress.coordinates}
                                    <br></br>
                                    Zona: {itemAddress.geoadmin1}
                                    <br></br>
                                    Region: {itemAddress.geoadmin2}
                                    <br></br>
                                    Provincia: {itemAddress.geoadmin3}
                                    <br></br>
                                    Cuidad: {itemAddress.geoadmin4}
                                    <br></br>
                                    Comuna: {itemAddress.geoadmin5}
                                    <br></br>
                                    GeoAdmin 6: {itemAddress.geoadmin6}
                                    <br></br>
                                    GeoAdmin 7: {itemAddress.geoadmin7}
                                    <br></br>
                                    GeoAdmin 8: {itemAddress.geoadmin8}
                                    <br></br>
                                  </div>
                                </div>
                                <span
                                  style={{ cursor: "pointer" }}
                                  className="	glyphicon glyphicon-search"
                                ></span>
                              </abbr>
                            </td>
                          </>
                        ) : (
                          <>
                            <h1>no tiene permisos para ver</h1>
                          </>
                        )}
                      </>
                    )}
                  </tr>
                );
              });
            })}
          </tbody>
        </table>
      </div>
    </>
  );
  let historial = (
    <>
      <div className="col-md-12">
        <div className="col-md-4"></div>
        <div className="col-md-4"></div>
        <div className="col-md-4 text-right">
          <button
            className="btn  btn-primary"
            onClick={(event) => controlForm("Historial")}
          >
            Crear
          </button>
        </div>
      </div>
      <div className="col-md-12 table-responsive-causas">
        <Table
          id={8}
          type={1}
          elementos={[
            "Detalle",
            "Tipo",
            "Resultado",
            "Fecha de contacto",
            "Email asociado",
          ]}
        ></Table>
        <table className="table table-bordered" id="8">
          <Table
            id={8}
            type={2}
            elementos={[
              "Detalle",
              "Tipo",
              "Resultado",
              "Fecha de contacto",
              "Email asociado",
            ]}
          ></Table>
          <tbody className="ajusteTabladata">
            {historiesState.map((item, index) => {
              return (
                <tr key={index}>
                  {editable === index + "Historial" ? (
                    <>
                      <td>{index + 1}</td>
                      <td>
                        <input
                          value={item.details}
                          name="details"
                          onChange={(event) => {
                            handleInputChange(
                              index,
                              event,
                              sethistories,
                              historiesState
                            );
                          }}
                          className="form-control"
                        ></input>
                      </td>
                      <td>
                        <AutocompleteInputModule
                          suggestions={collActionTypeState.map((item) => {
                            return item.name;
                          })}
                          value={item.type}
                          name={"type"}
                          handleInput={handleInputChange}
                          setState={sethistories}
                          i={index}
                          state={historiesState}
                        ></AutocompleteInputModule>
                      </td>
                      <td>
                        <AutocompleteInputModule
                          suggestions={callActionsResultState.map((item) => {
                            return item.name;
                          })}
                          value={item.result}
                          name={"result"}
                          handleInput={handleInputChange}
                          setState={sethistories}
                          i={index}
                          state={historiesState}
                        ></AutocompleteInputModule>
                      </td>
                      <td>
                        <input
                          value={item.date}
                          name="date"
                          type={"date"}
                          onChange={(event) => {
                            handleInputChange(
                              index,
                              event,
                              sethistories,
                              historiesState
                            );
                          }}
                          className="form-control"
                        ></input>
                      </td>

                      <td> {item.agent_email}</td>
                      <td>
                        <abbr title="Confirmar Edición">
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={(e) => {
                              confirmarEdicion(
                                e,
                                item,
                                historiesState,
                                sethistories
                              );
                            }}
                            className="glyphicon glyphicon glyphicon-ok"
                          >
                            {" "}
                          </span>
                        </abbr>
                        <abbr title="Cancelar Edición">
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              cancelarEdicion(
                                item,
                                historiesState,
                                sethistories
                              );
                            }}
                            className="glyphicon glyphicon-share-alt"
                          ></span>
                        </abbr>
                      </td>
                    </>
                  ) : (
                    <>
                      {usuario.permisos.indexOf("Ver") > -1 ? (
                        <>
                          <td>{index + 1}</td>
                          <td> {item.details}</td>
                          <td> {item.type}</td>
                          <td> {item.result}</td>
                          <td> {item.date}</td>
                          <td> {item.agent_email}</td>

                          <td>
                            <abbr title="Editar Elemento">
                              {" "}
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  editar(
                                    index,
                                    historiesState,
                                    sethistories,
                                    "Historial"
                                  );
                                }}
                                className="glyphicon glyphicon-pencil"
                              >
                                {" "}
                              </span>
                            </abbr>
                            <EliminarElemento
                              endpoint={`coll_proc/history/${item.coll_action_id}`}
                              onSuccess={handleGetModuleHistorial}
                            />
                          </td>
                        </>
                      ) : (
                        <>
                          <h1>no tiene permisos para ver</h1>
                        </>
                      )}
                    </>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );

  let controlForm = (modulo) => {
    if (usuario.permisos.indexOf("Crear") > -1) {
      setIsOpen(modulo);
    } else {
      alert("no tiene permisos para crear este elemento");
    }
  };

  // ============================================================
  // Exhortos: tab CRUD auto-contenido. Estado, fetch y mutaciones
  // viven acá para no expandir más el resto del componente.
  // Importante: los hooks van ANTES del early-return `if (isLoading)`
  // para no violar rules-of-hooks.
  // ============================================================
  // Nota: `const [exhortos, setExhortos]` se declara más arriba,
  // antes de `datosGenerales`, porque ese JSX lo usa al evaluarse.
  const [exhortoForm, setExhortoForm] = useState({
    court_exhorted: "",
    role_exhorted: "",
    state_exhorted: "",
    start_date_exhorted: "",
  });
  const [exhortoEditingId, setExhortoEditingId] = useState(null);
  const [exhortoModalOpen, setExhortoModalOpen] = useState(false);

  const fetchExhortos = async () => {
    try {
      const res = await fetch(
        Parametros.urlApi + "coll_proc/exhortos?coll_proc_id=" + id,
        { headers: { Authorization: "Bearer " + usuario.key } }
      );
      if (res.ok) {
        const data = await res.json();
        setExhortos(Array.isArray(data) ? data : []);
      }
    } catch (e) {
      console.error("Error cargando exhortos", e);
    }
  };

  useEffect(() => {
    if (causaState.coll_proc_id) {
      fetchExhortos();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [causaState.coll_proc_id]);

  const openExhortoCreate = () => {
    setExhortoEditingId(null);
    setExhortoForm({
      court_exhorted: "",
      role_exhorted: "",
      state_exhorted: "",
      start_date_exhorted: "",
    });
    setExhortoModalOpen(true);
  };

  const openExhortoEdit = (row) => {
    setExhortoEditingId(row.id_exhorted);
    setExhortoForm({
      court_exhorted: row.court_exhorted || "",
      role_exhorted: row.role_exhorted || "",
      state_exhorted: row.state_exhorted || "",
      start_date_exhorted: row.start_date_exhorted
        ? String(row.start_date_exhorted).slice(0, 10)
        : "",
    });
    setExhortoModalOpen(true);
  };

  const saveExhorto = async () => {
    const { court_exhorted, role_exhorted, start_date_exhorted } = exhortoForm;
    // Tribunal, ROL y Fecha son obligatorios. Estado es opcional.
    if (!court_exhorted || !role_exhorted || !start_date_exhorted) {
      alert("Completá Tribunal, ROL y Fecha (Estado es opcional)");
      return;
    }
    const isEdit = exhortoEditingId !== null;
    const url = isEdit
      ? Parametros.urlApi + "coll_proc/exhorted/" + exhortoEditingId
      : Parametros.urlApi + "coll_proc/exhorted";
    const body = isEdit
      ? exhortoForm
      : { coll_proc_id: parseInt(id, 10), ...exhortoForm };
    try {
      const res = await fetch(url, {
        method: isEdit ? "PUT" : "POST",
        headers: {
          Authorization: "Bearer " + usuario.key,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(body),
      });
      if (res.ok) {
        setExhortoModalOpen(false);
        await fetchExhortos();
      } else {
        const detail = await res.json().catch(() => null);
        alert(detail?.detail?.[0]?.msg || detail?.detail || "Error al guardar exhorto");
      }
    } catch (e) {
      alert("Error de red al guardar exhorto");
    }
  };

  const removeExhorto = async (id_exhorted) => {
    if (!window.confirm("¿Eliminar este exhorto?")) return;
    try {
      const res = await fetch(
        Parametros.urlApi + "coll_proc/exhorted/" + id_exhorted,
        {
          method: "DELETE",
          headers: { Authorization: "Bearer " + usuario.key },
        }
      );
      if (res.ok) {
        await fetchExhortos();
      } else {
        alert("Error al eliminar");
      }
    } catch {
      alert("Error de red al eliminar");
    }
  };

  // Bypass del check de permisos de tabControl para Exhortos
  const openExhortosTab = (evt) => {
    const tabcontent = document.getElementsByClassName("tabcontent");
    for (let i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
    const tablinks = document.getElementsByClassName("tablinks");
    for (let i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    const el = document.getElementById("Exhortos");
    if (el) el.style.display = "block";
    if (evt && evt.currentTarget) evt.currentTarget.className += " active";
  };

  // Al montar Administrar Causas abrimos la pestaña Etapas por default.
  // El primer .tablinks del DOM es el boton "Etapas". Esperamos a que
  // isLoading sea false: mientras esta en true el componente renderea el
  // spinner y los tabs no existen en el DOM todavia.
  // Guard con useRef: hay DOS useEffect que hacen setIsLoading(true/false),
  // asi que isLoading pasa a false dos veces al montar el componente. Sin
  // guard, getModules("Etapas") se dispararia dos veces.
  const etapasAutoOpenedRef = useRef(false);
  useEffect(() => {
    if (isLoading) return;
    if (etapasAutoOpenedRef.current) return;
    if (!causaState.coll_proc_id) return;
    if (!(usuario.modulos && usuario.modulos.includes("Etapas"))) return;
    etapasAutoOpenedRef.current = true;
    const tabcontent = document.getElementsByClassName("tabcontent");
    for (let i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
    const tablinks = document.getElementsByClassName("tablinks");
    for (let i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    const el = document.getElementById("Etapas");
    if (el) el.style.display = "block";
    if (tablinks.length > 0) tablinks[0].className += " active";
    // Si el primer useEffect que carga la causa ya llamo getModules("Etapas",
    // ...) via usuario.modulos[0], no repetimos: evita un segundo fetch que
    // se ve como una leve recarga.
    if (usuario.modulos && usuario.modulos[0] !== "Etapas") {
      getModules("Etapas", causaState.coll_proc_id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, causaState.coll_proc_id]);

  if (isLoading) {
    return (
      <div className="App">
        <Sidebar tipo="1"></Sidebar>
        <br />
        <UserTab nombre={"Administrar Causas"}></UserTab>
        <div className="container" style={{ marginTop: "20vh" }}>
          <img className="loadingGif" src={loadGif} alt="Cargando..."></img>
        </div>
      </div>
    );
  }
  return (
    <div className="App">
      <Sidebar tipo="1"></Sidebar>
      <br />
      <UserTab nombre={"Administrar Causas"}></UserTab>
      <div className="container">
        {datosGenerales}
        <div className="">
          <br></br>
          <br></br>
          <br></br>
          {
            <div className="">
              {causaState.coll_proc_id ? (
                <div className="tab">
                  {/* <button className="tablinks active" id="botonInicial" onClick={(event) => tabControl(event, "DatosGenerales")}>Datos Generales</button> */}
                  <button
                    className="tablinks"
                    onClick={(event) => tabControl(event, "Etapas")}
                  >
                    Etapas
                  </button>
                  <button
                    className="tablinks"
                    onClick={(event) => tabControl(event, "Estados")}
                  >
                    Estados
                  </button>
                  <button
                    className="tablinks"
                    onClick={(event) => tabControl(event, "Pagos")}
                  >
                    Pagos
                  </button>
                  <button
                    className="tablinks"
                    onClick={(event) => tabControl(event, "Gastos Normales")}
                  >
                    Costas
                  </button>
                  <button
                    className="tablinks"
                    onClick={(event) => tabControl(event, "Títulos")}
                  >
                    Títulos
                  </button>
                  <button
                    className="tablinks"
                    onClick={(event) => tabControl(event, "Bienes")}
                  >
                    Bienes
                  </button>
                  <button
                    className="tablinks"
                    onClick={(event) => tabControl(event, "Contactos")}
                  >
                    Contactos
                  </button>

                  <button
                    className="tablinks"
                    onClick={(event) => tabControl(event, "Direcciones")}
                  >
                    Direcciones
                  </button>
                  <button
                    className="tablinks"
                    onClick={(event) => tabControl(event, "Historial")}
                  >
                    Historial
                  </button>
                  <button
                    className="tablinks"
                    onClick={(event) => openExhortosTab(event)}
                  >
                    Exhortos
                  </button>
                </div>
              ) : (
                ""
              )}

              <div id="Etapas" className="tabcontent">
                <h3>Etapas</h3>
                {estadoCarga ? (
                  <img
                    className="loadingGif"
                    src={loadGif}
                    alt="Cargando..."
                  ></img>
                ) : (
                  etapa
                )}
                <FormularioModulos
                  modalIsOpen={modalIsOpen}
                  setModalIsOpen={setIsOpen}
                  modulo={"Etapas"}
                  crear={crearEtapa}
                  listax2={persons
                    .filter((item) =>
                      causaState?.client_id
                        ? item.client === causaState.client_id
                        : true
                    )
                    .map((item) => ({
                      value: item.person_uid,
                      label: item.full_name,
                    }))}
                  listax3={subStages
                    .filter((item) =>
                      causaState?.client_id
                        ? item.client_id === causaState.client_id
                        : true
                    )
                    .map((item) => ({
                      value: item.stage_id,
                      label: item.name,
                      stage_type_name: item.stage_type_name,
                      client_id: item.client_id,
                    }))}
                  formulario={formularioStateStage}
                  setFormulario={setFormularioStateStage}
                ></FormularioModulos>
              </div>
              <div id="Pagos" className="tabcontent">
                <h3>Pagos</h3>
                {estadoCarga ? (
                  <img
                    className="loadingGif"
                    src={loadGif}
                    alt="Cargando..."
                  ></img>
                ) : (
                  pagos
                )}
                <FormularioModulos
                  modalIsOpen={modalIsOpen}
                  setModalIsOpen={setIsOpen}
                  modulo={"Pagos"}
                  crear={crearPago}
                  listax2={deudoresState.map((item) => {
                    return { value: item.id, label: item.value };
                  })}
                  listax={monedas.map((item) => {
                    return { value: item.currency_id, label: item.isocode };
                  })}
                  formulario={formularioStatePayments}
                  setFormulario={setFormularioStatePayments}
                ></FormularioModulos>
              </div>
              <div id="Estados" className="tabcontent">
                <h3>Estados</h3>
                {estadoCarga ? (
                  <img
                    className="loadingGif"
                    src={loadGif}
                    alt="Cargando..."
                  ></img>
                ) : (
                  estado
                )}
                <FormularioModulos
                  modalIsOpen={modalIsOpen}
                  setModalIsOpen={setIsOpen}
                  modulo={"Estados"}
                  crear={crearEstado}
                  listax={estados.map((item) => {
                    return { value: item.state_id, label: item.name };
                  })}
                  formulario={formularioStateState}
                  setFormulario={setFormularioStateState}
                ></FormularioModulos>
              </div>
              <div id="Gastos Normales" className="tabcontent">
                <h3>Costas</h3>
                {estadoCarga ? (
                  <img
                    className="loadingGif"
                    src={loadGif}
                    alt="Cargando..."
                  ></img>
                ) : (
                  gastos
                )}
                <FormularioModulos
                  modalIsOpen={modalIsOpen}
                  setModalIsOpen={setIsOpen}
                  modulo={"Gastos Normales"}
                  crear={crearGasto}
                  listax={expensConceptState.map((item) => {
                    return { value: item.concept_id, label: item.name };
                  })}
                  listax2={monedas.map((item) => {
                    return { value: item.currency_id, label: item.isocode };
                  })}
                  listax3={receptors.map((item) => {
                    return { value: item.person_uid, label: item.full_name };
                  })}
                  facturaStatusTypes={facturaStatusTypes}
                  formulario={formularioStateExpenses}
                  setFormulario={setFormularioStateExpenses}
                ></FormularioModulos>
              </div>
              <div id="Títulos" className="tabcontent">
                <h3>Títulos</h3>
                {estadoCarga ? (
                  <img
                    className="loadingGif"
                    src={loadGif}
                    alt="Cargando..."
                  ></img>
                ) : (
                  titulos
                )}
                <FormularioModulos
                  listax3={debts.map((item) => {
                    return { value: item.debt_id, label: item.valor };
                  })}
                  listax={titulosState.map((item) => {
                    return { value: item.title_type_id, label: item.name };
                  })}
                  listax2={monedas.map((item) => {
                    return { value: item.currency_id, label: item.isocode };
                  })}
                  modalIsOpen={modalIsOpen}
                  setModalIsOpen={setIsOpen}
                  modulo={"Títulos"}
                  crear={crearTitulo}
                  formulario={formularioStateTitle}
                  setFormulario={setFormularioStateTitle}
                ></FormularioModulos>
              </div>
              <div id="Bienes" className="tabcontent">
                <h3>Bienes</h3>
                {estadoCarga ? (
                  <img
                    className="loadingGif"
                    src={loadGif}
                    alt="Cargando..."
                  ></img>
                ) : (
                  bienes
                )}
                <FormularioModulos
                  modalIsOpen={modalIsOpen}
                  listax5={direccionState.map((item) => {
                    return {
                      value: item.address_id,
                      label: item.street + " " + item.unit_number,
                    };
                  })}
                  listax6={origenDatosState.map((item) => {
                    return { value: item.origin_id, label: item.description };
                  })}
                  listax4={monedas.map((item) => {
                    return { value: item.currency_id, label: item.isocode };
                  })}
                  listax2={tipoActivosState.map((item) => {
                    return { value: item.asset_type_id, label: item.name };
                  })}
                  listax={conceptoDeudaState.map((item) => {
                    return { value: item.debt_concept_id, label: item.name };
                  })}
                  listax7={persons.map((item) => {
                    return {
                      value: item.person_uid,
                      label: item.full_name,
                    };
                  })}
                  formulario={formularioStateBienes}
                  setFormulario={setFormularioStateBienes}
                  setModalIsOpen={setIsOpen}
                  modulo={"Bienes"}
                  crear={crearBienes}
                ></FormularioModulos>
              </div>
              <div id="Contactos" className="tabcontent">
                <h3>Contactos</h3>
                {estadoCarga ? (
                  <img
                    className="loadingGif"
                    src={loadGif}
                    alt="Cargando..."
                  ></img>
                ) : (
                  contacto
                )}
                <FormularioModulos
                  listax4={deudoresState.map((item) => {
                    return { value: item.id, label: item.value };
                  })}
                  listax={origenDatosState.map((item) => {
                    return { value: item.origin_id, label: item.description };
                  })}
                  listax2={tipoContactoState.map((item) => {
                    return { value: item.contact_type_id, label: item.name };
                  })}
                  listax3={claseContactoState.map((item) => {
                    return { value: item.contact_class_id, label: item.name };
                  })}
                  formulario={formularioStateContacto}
                  setFormulario={setFormularioStateContacto}
                  modalIsOpen={modalIsOpen}
                  setModalIsOpen={setIsOpen}
                  modulo={"Contactos"}
                  crear={crearContacto}
                ></FormularioModulos>
              </div>
              <div id="Direcciones" className="tabcontent">
                <h3>Direcciones</h3>
                {estadoCarga ? (
                  <img
                    className="loadingGif"
                    src={loadGif}
                    alt="Cargando..."
                  ></img>
                ) : (
                  direcciones
                )}
                <FormularioModulos
                  listax4={direccionState.map((item) => {
                    return {
                      value: item.address_id,
                      label:
                        item.street +
                        " " +
                        item.unit_number +
                        "-" +
                        item.address_id,
                    };
                  })}
                  listax={tipoDireccion.map((item) => {
                    return { value: item.address_type_id, label: item.name };
                  })}
                  listax2={direccion_unit.map((item) => {
                    return { value: item.address_unit_id, label: item.name };
                  })}
                  listax3={origenDatosState.map((item) => {
                    return { value: item.origin_id, label: item.description };
                  })}
                  modalIsOpen={modalIsOpen}
                  setModalIsOpen={setIsOpen}
                  modulo={"Direcciones"}
                  crear={crearDireccion}
                  formulario={formularioAddressState}
                  setFormulario={setFormularioAddressState}
                ></FormularioModulos>
              </div>
              <div id="Historial" className="tabcontent">
                <h3>Historial</h3>
                {estadoCarga ? (
                  <img
                    className="loadingGif"
                    src={loadGif}
                    alt="Cargando..."
                  ></img>
                ) : (
                  historial
                )}

                <FormularioModulos
                  modalIsOpen={modalIsOpen}
                  setModalIsOpen={setIsOpen}
                  modulo={"Historial"}
                  crear={crearHistorial}
                  listax2={callActionsResultState.map((item) => {
                    return {
                      value: item.call_action_result_id,
                      label: item.name,
                    };
                  })}
                  listax={collActionTypeState.map((item) => {
                    return {
                      value: item.call_action_type_id,
                      label: item.name,
                    };
                  })}
                  formulario={formularioStateHistorial}
                  setFormulario={setFormularioStateHistorial}
                ></FormularioModulos>
              </div>

              <div id="Exhortos" className="tabcontent">
                <h3>Exhortos</h3>
                <div style={{ marginBottom: 12 }}>
                  <button
                    type="button"
                    onClick={openExhortoCreate}
                    className="btn btn-primary"
                  >
                    + Crear
                  </button>
                </div>
                <div className="table-responsive">
                  <table className="table table-bordered table-hover" style={{ background: "#fff" }}>
                    <thead>
                      <tr>
                        <th>Id</th>
                        <th>Tribunal</th>
                        <th>ROL</th>
                        <th>Estado</th>
                        <th>Fecha inicio</th>
                        <th>Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      {exhortos.length === 0 && (
                        <tr>
                          <td colSpan={6} style={{ textAlign: "center", padding: 16 }}>
                            Sin exhortos para esta causa.
                          </td>
                        </tr>
                      )}
                      {exhortos.map((row) => (
                        <tr key={row.id_exhorted}>
                          <td>{row.id_exhorted}</td>
                          <td>{row.court_exhorted}</td>
                          <td>{row.role_exhorted}</td>
                          <td>{row.state_exhorted}</td>
                          <td>
                            {row.start_date_exhorted
                              ? String(row.start_date_exhorted).slice(0, 10)
                              : ""}
                          </td>
                          <td>
                            <abbr title="Editar Elemento">
                              <span
                                style={{ cursor: "pointer", marginRight: 12 }}
                                onClick={() => openExhortoEdit(row)}
                                className="glyphicon glyphicon-pencil"
                              ></span>
                            </abbr>
                            <EliminarElemento
                              endpoint={`coll_proc/exhorted/${row.id_exhorted}`}
                              onSuccess={fetchExhortos}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {exhortoModalOpen && (
                  <div
                    style={{
                      position: "fixed",
                      inset: 0,
                      background: "rgba(0,0,0,0.5)",
                      zIndex: 1000,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    onClick={() => setExhortoModalOpen(false)}
                  >
                    <div
                      style={{
                        background: "#fff",
                        padding: 24,
                        borderRadius: 6,
                        minWidth: 480,
                        maxWidth: "90vw",
                      }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <h4 style={{ marginTop: 0 }}>
                        {exhortoEditingId ? "Editar Exhorto" : "Crear Exhorto"}
                      </h4>

                      <div style={{ marginBottom: 12 }}>
                        <label>Tribunal</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Ej: 4° Antofagasta"
                          value={exhortoForm.court_exhorted}
                          onChange={(e) =>
                            setExhortoForm({ ...exhortoForm, court_exhorted: e.target.value })
                          }
                        />
                      </div>

                      <div style={{ marginBottom: 12 }}>
                        <label>ROL</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Ej: E-1308-2026"
                          value={exhortoForm.role_exhorted}
                          onChange={(e) =>
                            setExhortoForm({ ...exhortoForm, role_exhorted: e.target.value })
                          }
                        />
                      </div>

                      <div style={{ marginBottom: 12 }}>
                        <label>Estado</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Ej: EMBARGADO"
                          value={exhortoForm.state_exhorted}
                          onChange={(e) =>
                            setExhortoForm({ ...exhortoForm, state_exhorted: e.target.value })
                          }
                        />
                      </div>

                      <div style={{ marginBottom: 16 }}>
                        <label>Fecha de inicio</label>
                        <input
                          type="date"
                          className="form-control"
                          value={exhortoForm.start_date_exhorted}
                          onChange={(e) =>
                            setExhortoForm({
                              ...exhortoForm,
                              start_date_exhorted: e.target.value,
                            })
                          }
                        />
                      </div>

                      <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
                        <button
                          type="button"
                          className="btn btn-default"
                          onClick={() => setExhortoModalOpen(false)}
                        >
                          Cancelar
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={saveExhorto}
                        >
                          {exhortoEditingId ? "Guardar" : "Crear"}
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          }
        </div>
      </div>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
    </div>
  );
}

export default withRouter(AdministracionCausas);
